import React, { useEffect, useState } from "react";
import { Button, Card, FormControl, InputGroup, Table } from "react-bootstrap";
import CustomeFormCreater from "../../../../../components/common/formCreater/CustomeFormCreater";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  addAwrRequest,
  fetchCategoryRequest,
  fetchGradeRequest,
  fetchInvoiceDetailsRequest,
  fetchMarkRequest,
  fetchSaleProgramListRequest,
  fetchSubTeaTypeRequest,
  fetchWarehouseUserRequest,
  teaTypeAction,
  uploadSampleShortageRequest,
} from "../../../../../store/actions";
import { fetchSaleNumbersRequest } from "../../../../../store/actions/createdSaleNo/CreatedSaleNo";
import { useFormik } from "formik";
import axios from "axios";
import { setRef } from "@mui/material";
import FileUpload from "../../../../../components/common/uploadFile/FileUpload";
import {
  checkAllcoulm,
  readFileAndCheckHeaders,
} from "../../../../../components/common/uploadFile/utils";
import { useRef } from "react";
import TableComponent from "../../../../../components/tableComponent/TableComponent";
import DeleteIcon from "@mui/icons-material/Delete";
import axiosMain from "../../../../../http/axios/axios_main";
import CustomToast from "../../../../../components/Toast";
import { useAuctionDetail } from "../../../../../components/common/AunctioneerDeteailProvider";
import formatDateToDdMmYy from "../../../../../components/common/dateAndTime/convertToDate";

import PrintInvoice from "../../../../../components/common/Print/print";
import Modals from "../../../../../components/common/Modal";
import { useLoader } from "../../../../../components/common/Loder/Loder";
import newformatDateToDdMmYy from "../../../../../components/common/dateAndTime/newconvertToDate";
const currentDate = new Date().toISOString()?.split("T")[0];

// Get the current year
const currentYear = new Date().getFullYear();

const currentWeek = Math.ceil(
  ((currentDate - new Date(currentYear, 0, 4)) / 86400000 + 1) / 7
);
const convertDateFormat = (date) => {
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
};
const validationSchema = Yup.object().shape({
  gatePassQuantity: Yup.number().required("Gate Pass Quantity is required"),
  // awrRefNo: Yup.string().required("AWR Ref No is required"),
  arrivalDate: Yup.date().required("Arrival Date is required"),
  // awrDate: Yup.date().required("AWR Date is required"),
  catalogClosingDate: Yup.date().required("Catalog Closing Date is required"),
  invoiceDate: Yup.date().required("Invoice Date is required"),
  //  gpNumber: Yup.number().required("GP Number is required").typeError("GP Number must be a number"),
  //  gpDate: Yup.date().required("GP Date is required"),
});

// const handleSubmit = (fromData) => {
//   // setUploadedData(fromData);
//   const data = {
//     season: fromData.season,
//     saleNo: fromData.saleNo,
//     gpQty: 800,
//     awrReferenceNo: fromData.awrReferenceNo,
//     markId: fromData.mark,
//     wareHouseUserRegId: fromData.wareHouseUserRegId,
//     arrivalDate: fromData.arrivalDate,
//     awrDate: fromData.awrDate,
//     catalogClosingDate: fromData.catalogClosingDate,
//     invoiceDate: fromData.invoiceDate,
//     factoryName: fromData.factoryName,
//     gradeId: fromData.gradeId,
//     awrInvoices: fromData.awrInvoices,
//   };
//   console.log(data);
// };
const initialValues = {
  season: currentYear?.toString()?.trim(),
  saleNo: "",
  SaleProgramId: 0,
  gatePassQuantity: null,
  awrRefNo: "",
  mark: "",
  warehouse: "",
  arrivalDate: "",
  awrDate: "",
  catalogClosingDate: "",
  invoiceDate: "",
  manufacture: "",
  grade: 0,
  gpNo: "",
  gpDate: "",
  awrInvoices: [],
};

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ALLOWED_EXTENSIONS = [".xls", ".xlsx"];

function UploadForm({
  isDisabled,
  setExpandedTab,
  actionData,
  currentDate,
  modalRight,
  getAwr,
  expandedTab,
}) {
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    roleCode,
    auction,
    auctioneerCode,
    auctionTypeMasterCode,
  } = useAuctionDetail();
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();
  const [auctionType, setAuctionType] = useState(auction);
  const [auctionTypeCode, setAuctionTypeCode] = useState(auctionTypeMasterCode);
  const baseUrlEngn =
    auction === "ENGLISH" ? "EnglishAuctionAWRDetails" : "AWRDetails";
  const [baseUrlEng, setbaseUrlEng] = useState(baseUrlEngn);
  const [catalogclosedate, setCatalogclosingDate] = useState("");
  const [uploadedData, setUploadedData] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [teaTypeList, setTeaTeatypeList] = useState([]);
  const [markDataList, setMarkDataList] = useState([]);
  const [warehouseUserList, setWarehouseUserList] = useState([]);
  const [gradesList, setGradesList] = useState([]);
  const [saleNo, setSaleNo] = useState([]);
  const [subTeaTypeNo, setSubTeaTypeNo] = useState([]);
  const [catagory, setCategory] = useState([]);
  const [saleprogram, setsaleprogrm] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [handleChnage, setHandleChnage] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [invoiceDataList, setInvoiceDataList] = useState([]);
  const [sampleList, setSampleList] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [validationData, setValidationData] = useState([]);
  const fileInputRef = useRef(null);
  const [openConformationModals, setopenConformationModalss] = useState(false);
  const [isNotCurrectSaleNo, setIsNotCurrectSaleNo] = useState("");

  // const [propertyNameList, setPropertyNameList] = useState([
  //   {
  //     name: "Mark",
  //     title: "Mark",
  //   },
  //   { name: "season", title: "Season" },
  //   {
  //     name: "TeaType",
  //     title: "Tea Type",
  //   },
  //   { name: "saleNo", title: "Sale No" },
  //   {
  //     name: "Warehouse",
  //     title: "Warehouse User Registration",
  //   },
  //   // { name: "auctioneerId", title: "Auctioneer ID" },
  //   {
  //     name: "Category",
  //     title: "Category",
  //   },
  //   { name: "manufactureFromDate", title: "Manufacture From Date" },
  //   { name: "manufactureToDate", title: "Manufacture To Date" },
  //   { name: "dateOfDispatch", title: "Date of Dispatch" },
  //   { name: "invoiceDate", title: "Invoice Date" },
  //   { name: "carrier", title: "Carrier" },
  //   { name: "lorryReceiptNo", title: "Lorry Receipt Number" },
  //   { name: "lorryNo", title: "Lorry Number" },
  //   { name: "invoiceNo", title: "Invoice Number" },
  //   { name: "arrivalDate", title: "Arrival Date" },
  //   { name: "awrDate", title: "AWR Date" },
  //   { name: "awrReferenceNo", title: "AWR Reference Number" },
  //   {
  //     name: "SubTeaType",
  //     title: "Sub Tea Type",
  //   },
  //   {
  //     name: "Grade",
  //     title: "Grade",
  //   },
  //   {
  //     name: "packageType",
  //     title: "Package Type",
  //     getCellValue: ({ ...row }) => <span>Paper sacks</span>,
  //   },
  //   {
  //     name: "packageSize",
  //     title: "Package Size",
  //     getCellValue: ({ ...row }) => <span> 27x21x11</span>,
  //   },
  //   { name: "packageNo", title: "Package Number" },
  //   { name: "totalPackages", title: "Total Packages" },
  //   { name: "grossKgs", title: "Gross Kgs" },
  //   { name: "tareKgs", title: "Tare Kgs" },
  //   { name: "netKgs", title: "Net Kgs" },
  //   { name: "totalNetKgs", title: "Total Net Kgs" },
  //   { name: "gpNo", title: "GP Number" },
  //   { name: "gpDate", title: "GP Date" },
  //   { name: "shortExcessWeight", title: "Short Excess Weight" },
  //   { name: "locationInsideWarehouse", title: "Location Inside Warehouse" },
  //   // {
  //   //   name: "isActive",
  //   //   title: "Is Active",
  //   //   getCellValue: ({ ...row }) => (
  //   //     <span>{row.isActive == true ? "true" : "false"}</span>
  //   //   ),
  //   // },
  //   // { name: "createdBy", title: "Created By" },
  //   { name: "invoiceQty", title: "Invoice Qty" },
  //   // {
  //   //   name: "action",
  //   //   title: "Action",
  //   //   getCellValue: ({ ...row }) => <ActionArea data={row} />,
  //   // },
  // ]);
  const [propertyNameList, setPropertyNameList] = useState(
    // auction !== "ENGLISH"
    //   ?
    [
      {
        name: "Mark",
        title: "Mark",
      },
      { name: "season", title: "Season" },
      {
        name: "TeaType",
        title: "Tea Type",
      },
      { name: "saleNo", title: "Sale No" },
      {
        name: "Warehouse",
        title: "Warehouse Unit Short Name",
      },
      // { name: "auctioneerId", title: "Auctioneer ID" },
      {
        name: "Category",
        title: "Category",
      },
      {
        name: "manufactureFromDate",
        title: "Manufacture From Date",
        getCellValue: ({ ...row }) => (
          <span>{newformatDateToDdMmYy(row?.manufactureFromDate)}</span>
        ),
      },
      {
        name: "manufactureToDate",
        title: "Manufacture To Date",
        getCellValue: ({ ...row }) => (
          <span>{newformatDateToDdMmYy(row?.manufactureToDate)}</span>
        ),
      },
      {
        name: "dateOfDispatch",
        title: "Date of Dispatch",
        getCellValue: ({ ...row }) => (
          <span>{newformatDateToDdMmYy(row?.dateOfDispatch)}</span>
        ),
      },
      {
        name: "invoiceDate",
        title: "Invoice Date",
        getCellValue: ({ ...row }) => (
          <span>{newformatDateToDdMmYy(row?.invoiceDate)}</span>
        ),
      },
      { name: "carrier", title: "Carrier" },
      { name: "lorryReceiptNo", title: "Lorry Receipt Number" },
      { name: "lorryNo", title: "Lorry Number" },
      { name: "invoiceNo", title: "Invoice Number" },
      { name: "cess", title: "Cess" },
      { name: "basic_AED", title: "Basic/A.E.D" },
      { name: "dutyPayable", title: "Duty Payable" },
      {
        name: "arrivalDate",
        title: "Arrival Date",
        getCellValue: ({ ...row }) => (
          <span>{newformatDateToDdMmYy(row?.arrivalDate)}</span>
        ),
      },
      {
        name: "awrDate",
        title: "AWR Date",
        getCellValue: ({ ...row }) => (
          <span>{newformatDateToDdMmYy(row?.awrDate)}</span>
        ),
      },
      { name: "awrReferenceNo", title: "AWR Reference Number" },
      {
        name: "SubTeaType",
        title: "Sub Tea Type",
      },
      {
        name: "Grade",
        title: "Grade",
      },
      {
        name: "packageType",
        title: "Package Type",
        // getCellValue: ({ ...row }) => <span>Paper sacks</span>,
      },
      {
        name: "packageSize",
        title: "Package Size",
        // getCellValue: ({ ...row }) => <span> 27x21x11</span>,
      },
      { name: "packageNo", title: "Package Number" },
      { name: "totalPackages", title: "Total Packages" },
      { name: "grossKgs", title: "Gross Kgs" },
      { name: "tareKgs", title: "Tare Kgs" },
      { name: "netKgs", title: "Net Kgs" },
      { name: "totalNetKgs", title: "Total Net Kgs" },
      { name: "gpNo", title: "GP Number" },
      {
        name: "gpDate",
        title: "GP Date",
        getCellValue: ({ ...row }) => (
          <span>{newformatDateToDdMmYy(row?.gpDate)}</span>
        ),
      },
      { name: "shortExcessWeight", title: "Short Excess Weight" },
      {
        name: "locationInsideWarehouse",
        title: "Location Inside Warehouse",
      },
      // {
      //   name: "isActive",
      //   title: "Is Active",
      //   getCellValue: ({ ...row }) => (
      //     <span>{row.isActive == true ? "true" : "false"}</span>
      //   ),
      // },
      // { name: "createdBy", title: "Created By" },
      { name: "invoiceQty", title: "Invoice Qty" },
      // {
      //   name: "action",
      //   title: "Action",
      //   getCellValue: ({ ...row }) => <ActionArea data={row} />,
      // },
    ]
    // : [
    //     {
    //       name: "Mark",
    //       title: "Mark",
    //     },
    //     { name: "season", title: "Season" },
    //     {
    //       name: "TeaType",
    //       title: "Tea Type",
    //     },
    //     { name: "saleNo", title: "Sale No" },
    //     {
    //       name: "Warehouse",
    //       title: "Warehouse Unit Short Name",
    //     },
    //     // { name: "auctioneerId", title: "Auctioneer ID" },
    //     {
    //       name: "Category",
    //       title: "Category",
    //     },
    //     {
    //       name: "manufactureFromDate",
    //       title: "Manufacture From Date",
    //       getCellValue: ({ ...row }) => (
    //         <span>{newformatDateToDdMmYy(row?.manufactureFromDate)}</span>
    //       ),
    //     },
    //     {
    //       name: "manufactureToDate",
    //       title: "Manufacture To Date",
    //       getCellValue: ({ ...row }) => (
    //         <span>{newformatDateToDdMmYy(row?.manufactureToDate)}</span>
    //       ),
    //     },
    //     {
    //       name: "dateOfDispatch",
    //       title: "Date of Dispatch",
    //       getCellValue: ({ ...row }) => (
    //         <span>{newformatDateToDdMmYy(row?.dateOfDispatch)}</span>
    //       ),
    //     },
    //     {
    //       name: "invoiceDate",
    //       title: "Invoice Date",
    //       getCellValue: ({ ...row }) => (
    //         <span>{newformatDateToDdMmYy(row?.invoiceDate)}</span>
    //       ),
    //     },
    //     { name: "carrier", title: "Carrier" },
    //     { name: "lorryReceiptNo", title: "Lorry Receipt Number" },
    //     { name: "lorryNo", title: "Lorry Number" },
    //     { name: "invoiceNo", title: "Invoice Number" },
    //     {
    //       name: "arrivalDate",
    //       title: "Arrival Date",
    //       getCellValue: ({ ...row }) => (
    //         <span>{newformatDateToDdMmYy(row?.arrivalDate)}</span>
    //       ),
    //     },
    //     {
    //       name: "awrDate",
    //       title: "AWR Date",
    //       getCellValue: ({ ...row }) => (
    //         <span>{newformatDateToDdMmYy(row?.awrDate)}</span>
    //       ),
    //     },
    //     { name: "awrReferenceNo", title: "AWR Reference Number" },
    //     {
    //       name: "SubTeaType",
    //       title: "Sub Tea Type",
    //     },
    //     {
    //       name: "Grade",
    //       title: "Grade",
    //     },
    //     {
    //       name: "packageType",
    //       title: "Package Type",
    //       // getCellValue: ({ ...row }) => <span>Paper sacks</span>,
    //     },
    //     {
    //       name: "packageSize",
    //       title: "Package Size",
    //       // getCellValue: ({ ...row }) => <span> 27x21x11</span>,
    //     },
    //     { name: "packageNo", title: "Package Number" },
    //     { name: "totalPackages", title: "Total Packages" },
    //     { name: "grossKgs", title: "Gross Kgs" },
    //     { name: "tareKgs", title: "Tare Kgs" },
    //     { name: "netKgs", title: "Net Kgs" },
    //     { name: "totalNetKgs", title: "Total Net Kgs" },
    //     { name: "gpNo", title: "GP Number" },
    //     {
    //       name: "gpDate",
    //       title: "GP Date",
    //       getCellValue: ({ ...row }) => (
    //         <span>{newformatDateToDdMmYy(row?.gpDate)}</span>
    //       ),
    //     },
    //     { name: "shortExcessWeight", title: "Short Excess Weight" },
    //     {
    //       name: "locationInsideWarehouse",
    //       title: "Location Inside Warehouse",
    //     },
    //     // {
    //     //   name: "isActive",
    //     //   title: "Is Active",
    //     //   getCellValue: ({ ...row }) => (
    //     //     <span>{row.isActive == true ? "true" : "false"}</span>
    //     //   ),
    //     // },
    //     // { name: "createdBy", title: "Created By" },
    //     { name: "invoiceQty", title: "Invoice Qty" },
    //     // {
    //     //   name: "action",
    //     //   title: "Action",
    //     //   getCellValue: ({ ...row }) => <ActionArea data={row} />,
    //     // },
    //   ]
  );
  const [checked, setChecked] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [allCheked, setAllChacked] = useState(false);
  const [openPrintModel, setopenPrintModel] = useState(false);
  const [printrow, setprintrow] = useState([]);
  const [AwrPrintArr, setAwrPrintArr] = useState([]);
  const [
    openModalConformationInvalidData,
    setOpenModalConformationInvalidData,
  ] = useState(false);
  const [
    openModalConformationInvalidDataTitle,
    setOpenModalConformationInvalidDataTitle,
  ] = useState({});

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) => {
      setPropertyNameList(propertyNames);

      const {
        arrivalDate,
        awrdDate,
        awrRefNo,
        gatePassQuantity,
        SaleProgramId,
      } = values;
      let awrData = {
        season: values.season,
        saleNo: parseInt(values.saleNo),
        invoiceDate: values.invoiceDate,
        SaleProgramId: SaleProgramId,
        arrivalDate:
          invoiceDataList?.at(0).arrivalDate !== null
            ? invoiceDataList?.at(0)?.arrivalDate?.split("T")?.at(0)
            : arrivalDate,
        awrDate:
          invoiceDataList?.at(0).awrDate !== null
            ? invoiceDataList?.at(0)?.awrDate?.split("T")?.at(0)
            : awrdDate,
        awrRefNo: awrRefNo,
        gatePassQuantity: gatePassQuantity,
        createdBy: userId,
        updatedBy: userId,
        packageType: "15",
        gradeId: parseInt(formik.values.grade),
        auctionCenterId: auctionCenterId,
        auctioneerId: userId,
        Auctioneer: auctioneerCode,
      };

      const data = invoiceDataList?.map((ele) => {
        return {
          ...ele,
          ...awrData,
        };
      });
      console.log(data, "555");
      formik.values.gatePassQuantity = "";
      setTableData(data);
      // formik.resetForm();
      setHandleChnage(true);
    },
    validateOnBlur: false, // Disable validation on blur
    validateOnChange: false, // Disable validation on change
    // validateOnBlur: true,
    isInitialValid: true,
  });

  const dispatch = useDispatch();

  const teaType = useSelector(
    (state) => state.teaType.teaTypeList.responseData
  );
  const subTeaType = useSelector((state) => state.teaType.data.responseData);

  const markList = useSelector((state) => state.mark.data.responseData);
  const warehouseUsersList = useSelector(
    (state) => state.warehouseUser.data.responseData
  );
  const grades = useSelector((state) => state.grade.data.responseData);

  const saleNumber = useSelector(
    (state) => state?.CreatedSaleNo?.saleNumbers?.responseData
  );
  const category = useSelector((state) => state?.category?.data?.responseData);

  const invoiceData = useSelector(
    (state) => state?.invoiceDetails?.data?.responseData
  );

  console.log(invoiceData, "invoiceData");

  useEffect(() => {
    dispatch(teaTypeAction({ auctionCenterId }));
    dispatch(fetchMarkRequest({ auctionCenterId }));
    dispatch(fetchWarehouseUserRequest({ auctionCenterId }));
    dispatch(fetchGradeRequest({ auctionCenterId }));
    // dispatch(fetchSaleProgramListRequest(saleData));
    dispatch(
      fetchCategoryRequest({
        teaTypeId: parseInt(formik.values.teaType),
        auctionCenterId,
      })
    );
    dispatch(fetchSaleNumbersRequest(formik.values.season));
    const today = new Date();

    // Format today's date to YYYY-MM-DD
    const formattedDate = today.toISOString().split("T")[0];
    console.log(formattedDate);
    formik.setFieldValue(
      "awrdDate",
      actionData?.at(0)?.awrDate !== undefined
        ? actionData?.at(0)?.awrDate
        : formattedDate
    );
    formik.setFieldValue(
      "arrivalDate",
      actionData?.at(0)?.awrDate !== undefined
        ? actionData?.at(0)?.awrDate
        : formattedDate
    );
    formik.values.arrivalDate =
      actionData?.at(0)?.awrDate !== undefined
        ? actionData?.at(0)?.awrDate
        : formattedDate;
  }, []);

  useEffect(() => {
    if (formik.values.awrDate === "") {
      const today = new Date();

      // Format today's date to YYYY-MM-DD
      const formattedDate = today.toISOString().split("T")[0];
      // console.log(formattedDate);
      formik.setFieldValue(
        "awrdDate",
        actionData?.at(0)?.awrDate !== undefined
          ? actionData?.at(0)?.awrDate
          : formattedDate
      );
      formik.values.awrdDate =
        actionData?.at(0)?.awrDate !== undefined
          ? actionData?.at(0)?.awrDate
          : formattedDate;
    }
  }, [formik.values.awrdDate]);

  useEffect(() => {
    formik.setFieldValue("awrdDate", currentDate);
    setTableData([]);
    setSelectedData([]);
  }, [currentDate]);

  useEffect(() => {
    const today = new Date();

    // Format today's date to YYYY-MM-DD
    const formattedDate = today.toISOString().split("T")[0];
    console.log(formattedDate);
    // formik.setFieldValue("arrivalDate", formattedDate);
  }, [formik.values.arrivalDate]);

  useEffect(() => {
    setTeaTeatypeList(teaType);
    setMarkDataList(markList);
    setWarehouseUserList(warehouseUsersList);
    setGradesList(grades);
    setSaleNo(saleNumber);
    setSubTeaTypeNo(subTeaType);
    setCategory(category);

    //set value
    if (markList?.length > 0) {
      formik.setFieldValue("mark", markList[0]?.markId);
    }
    if (warehouseUsersList?.length > 0) {
      formik.setFieldValue(
        "warehouse",
        warehouseUsersList[0]?.wareHouseUserRegId
      );
    }
    if (grades?.length > 0) {
      formik.setFieldValue("grade", grades[0]?.gradeId);
    }
  }, [
    teaType,
    subTeaType,
    markList,
    warehouseUsersList,
    grades,
    saleNumber,
    category,
  ]);
  const handlePrint = () => {
    window.print();
  };
  useEffect(() => {
    console.log(
      actionData,
      markDataList
        ?.filter((ele) => ele.markId === actionData?.at(0)?.markId)
        ?.at(0)?.markCode
    );
    // formik.setValues({
    //   season: actionData?.at(0)?.season,
    //   saleNo: actionData?.at(0)?.saleNo,
    //   SaleProgramId: 0,
    //   gatePassQuantity: actionData?.at(0)?.gpQty,
    //   awrRefNo: actionData?.at(0)?.awrReferenceNo,
    //   mark: actionData?.at(0)?.markId,
    //   warehouse: actionData?.at(0)?.wareHouseUserRegId,
    //   arrivalDate: actionData?.at(0)?.arrivalDate,
    //   awrdDate: actionData?.at(0)?.awrdDate,
    //   catalogClosingDate: actionData?.at(0)?.catalogClosingDate,
    //   invoiceDate: actionData?.at(0)?.invoiceDate,
    //   manufacture:"",
    //   grade: actionData?.at(0)?.gradeId,
    // });
    if (isDisabled) {
      formik.setFieldValue("seson", actionData?.at(0)?.season);
      formik.setFieldValue("saleNo", actionData?.at(0)?.saleNo);
      formik.setFieldValue("gatePassQuantity", actionData?.at(0)?.gpQty);
      formik.setFieldValue("awrRefNo", actionData?.at(0)?.awrReferenceNo);
      formik.setFieldValue(
        "mark",
        markDataList
          ?.filter((ele) => ele.markId === actionData?.at(0)?.markId)
          ?.at(0)?.markCode
      );
      formik.setFieldValue(
        "warehouse",
        warehouseUserList
          ?.filter(
            (ele) =>
              ele.wareHouseUserRegId === actionData?.at(0)?.wareHouseUserRegId
          )
          ?.at(0)?.wareHouseCode
      );
      formik.setFieldValue("arrivalDate", actionData?.at(0)?.arrivalDate);
      formik.setFieldValue("awrDate", actionData?.at(0)?.awrDate);
      formik.setFieldValue(
        "catalogClosingDate",
        actionData?.at(0)?.catalogClosingDate
      );
      formik.setFieldValue("invoiceDate", actionData?.at(0)?.invoiceDate);

      setTableData(actionData?.at(0)?.awrInvoices);
    }
  }, [actionData]);

  const handleCheckboxChange = (id) => {
    const isChecked = selectedData.some((item) => item.invoiceId === id);

    if (isChecked) {
      // If the checkbox is checked, remove the data from selectedData
      setSelectedData(selectedData.filter((item) => item.invoiceId !== id));
      // setAllChacked(selectedData.length === data.length ? true:false);
    } else {
      // If the checkbox is unchecked, add the data to selectedData
      const data2 = tableData.find((item) => item.invoiceId === id);
      setSelectedData([...selectedData, data2]);
      // setAllChacked(selectedData.length === data.length ? true:false);
    }
  };
  useEffect(() => {
    const seasondata = {
      season: formik.values.season.toString(),
      auctionCenterId: auctionCenterId,
    };
    axiosMain
      .post(`/preauction/Common/BindSaleNoBySeason`, seasondata)
      .then((res) => {
        setSaleNo(res.data.responseData);
        formik.setFieldValue("saleNo", res.data.responseData?.at(0).saleNo);
      })
      .catch((err) => console.log(err));
  }, [formik.values.season]);

  const ExecelpropertyNames = [
    {
      name: "Mark",
      title: "Mark",
    },
    { name: "season", title: "Season" },
    {
      name: "TeaType",
      title: "Tea Type",
    },
    { name: "saleNo", title: "Sale No" },
    {
      name: "Warehouse",
      title: "Warehouse Unit Short Name",
    },
    // { name: "auctioneerId", title: "Auctioneer ID" },
    {
      name: "Category",
      title: "Category",
    },
    {
      name: "manufactureFromDate",
      title: "Manufacture From Date",
      getCellValue: ({ ...row }) => (
        <span>{newformatDateToDdMmYy(row?.manufactureFromDate)}</span>
      ),
    },
    {
      name: "manufactureToDate",
      title: "Manufacture To Date",
      getCellValue: ({ ...row }) => (
        <span>{newformatDateToDdMmYy(row?.manufactureToDate)}</span>
      ),
    },
    {
      name: "dateOfDispatch",
      title: "Date of Dispatch",
      getCellValue: ({ ...row }) => (
        <span>{newformatDateToDdMmYy(row?.dateOfDispatch)}</span>
      ),
    },
    {
      name: "invoiceDate",
      title: "Invoice Date",
      getCellValue: ({ ...row }) => (
        <span>{newformatDateToDdMmYy(row?.invoiceDate)}</span>
      ),
    },
    { name: "carrier", title: "Carrier" },
    { name: "lorryReceiptNo", title: "Lorry Receipt Number" },
    { name: "lorryNo", title: "Lorry Number" },
    { name: "invoiceNo", title: "Invoice Number" },
    {
      name: "arrivalDate",
      title: "Arrival Date",
      getCellValue: ({ ...row }) => (
        <span>{newformatDateToDdMmYy(row?.arrivalDate)}</span>
      ),
    },
    {
      name: "awrDate",
      title: "AWR Date",
      getCellValue: ({ ...row }) => (
        <span>{newformatDateToDdMmYy(row?.awrDate)}</span>
      ),
    },
    { name: "awrReferenceNo", title: "AWR Reference Number" },
    {
      name: "SubTeaType",
      title: "Sub Tea Type",
    },
    {
      name: "Grade",
      title: "Grade",
    },
    {
      name: "packageType",
      title: "Package Type",
      // getCellValue: ({ ...row }) => <span>Paper sacks</span>,
    },
    {
      name: "packageSize",
      title: "Package Size",
      // getCellValue: ({ ...row }) => <span> 27x21x11</span>,
    },
    { name: "packageNo", title: "Package Number" },
    { name: "totalPackages", title: "Total Packages" },
    { name: "grossKgs", title: "Gross Kgs" },
    { name: "tareKgs", title: "Tare Kgs" },
    { name: "netKgs", title: "Net Kgs" },
    { name: "totalNetKgs", title: "Total Net Kgs" },
    { name: "gpNo", title: "GP Number" },
    {
      name: "gpDate",
      title: "GP Date",
      getCellValue: ({ ...row }) => (
        <span>{newformatDateToDdMmYy(row?.manufactureFromDate)}</span>
      ),
    },
    { name: "shortExcessWeight", title: "Short Excess Weight" },
    { name: "locationInsideWarehouse", title: "Location Inside Warehouse" },
    // {
    //   name: "isActive",
    //   title: "Is Active",
    //   getCellValue: ({ ...row }) => (
    //     <span>{row.isActive == true ? "true" : "false"}</span>
    //   ),
    // },
    // { name: "createdBy", title: "Created By" },
    { name: "invoiceQty", title: "Invoice Qty" },
    {
      name: "action",
      title: "Action",
      getCellValue: ({ ...row }) => <ActionArea data={row} />,
    },
  ];

  // useEffect(() => {
  //   if (expandedTab === "panel3") {
  //     setPropertyNameList(ExecelpropertyNames);
  //   }
  // }, [expandedTab]);

  useEffect(() => {
    formik.setFieldValue("awrInvoices", invoiceData || []);
  }, [invoiceData]);

  // useEffect(() => {
  //   if (formik.values.awrdDate !== "") {
  //     if (isDisabled === false) {
  //       const parsedDate1 = new Date(formik.values.awrdDate);
  //       const parsedDate2 = new Date(formik.values.catalogClosingDate);
  //       if (parsedDate1 <= parsedDate2) {
  //         formik.setFieldValue("awrdDate", formik.values.awrdDate);
  //       } else {
  //         formik.setFieldValue("awrdDate", "");
  //         CustomToast.error(
  //           "Arrival Date must me lessthen catlog closing date"
  //         );
  //       }
  //     }
  //   } else {
  //     formik.setFieldValue("awrdDate", "");
  //   }
  // }, [formik.values.awrdDate]);

  useEffect(() => {
    // console.log(formik.values.warehouse, "formik.values.warehouse");
    if (formik.values.mark !== "") {
      axiosMain
        .post(`/admin/factory/dropdown/getFactory`, {
          markId: parseInt(formik.values.mark),
          auctionCenterId,
        })
        .then((response) => {
          response.data.responseData?.map((ele) =>
            formik.setFieldValue("manufacture", ele.factoryName)
          );
        })
        .catch((err) => console.log(err));
    } else {
      console.log("Mark is missing");
    }
  }, [formik.values.mark]);

  useEffect(() => {
    console.log("api cal");
    const saleNo = formik.values.saleNo;
    const season = formik.values.season;
    // API endpoint URL
    const apiUrl = `/preauction/Common/GetSaleProgramDetailBySaleNo`;

    // Data to be sent in the POST request

    // Making the POST request using Axios
    if (saleNo !== "") {
      axiosMain
        .post(apiUrl, {
          saleNo: parseInt(saleNo),
          season: season,
          auctionCenterId: auctionCenterId,
        })
        .then((response) => {
          setbaseUrlEng(
            response?.data?.responseData[0]?.auctionTypeCode === "BHARAT"
              ? "AWRDetails"
              : "EnglishAuctionAWRDetails"
          );
          // Handle the API response here
          formik.setFieldValue(
            "catalogClosingDate",
            response?.data?.responseData[0]?.catalogClosingDate?.split("T")[0]
          );

          formik.setFieldValue(
            "SaleProgramId",
            response?.data?.responseData[0]?.SaleProgramId
          );
        })
        .catch((error) => {
          // Handle errors here
        });

      // Cleanup function, in case you need to cancel the request
      return () => {
        // Cancel the request (if necessary) to avoid memory leaks
      };
    }
  }, [formik.values.saleNo, formik.values.season]);

  function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = currentYear; i > currentYear - 7; i--) {
      options.push({ label: i, value: i });
    }

    return options;
  }

  // const handleFileUpload = (e) => {
  //   const { values, handleChange, handleSubmit, errors: formikErrors } = formik;

  //   const files = Array.from(e.target.files);
  //   const validFiles = files.filter(
  //     (file) =>
  //       file.type === "application/vnd.ms-excel" ||
  //       file.type ===
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //   );

  //   if (validFiles.length > 0) {
  //     setUploadedFiles((prevFiles) => [...prevFiles, ...validFiles]);
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       fileUpload: null,
  //     }));
  //   } else {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       fileUpload: "Please select valid Excel files",
  //     }));
  //   }
  // };

  const fields = [
    {
      label: "Season",
      name: "season",
      type: isDisabled ? "disable" : "select",
      options: generateYearOptions(),
      required: false,
      className: "FormGroup",
    },
    {
      label: "Sale No",
      name: "saleNo",
      type: isDisabled ? "disable" : "select",
      options: saleNo?.map((ele) => {
        return { label: ele.saleNo, value: ele.saleNo };
      }),
      required: false,
      className: "FormGroup",
    },
    {
      label: "Gate Pass Quantity",
      name: "gatePassQuantity",
      type: isDisabled ? "disable" : "disable",
      required: true,
      className: "FormGroup",
    },
    {
      label: "AWR Ref No",
      name: "awrRefNo",
      type: "disable",
      required: true,
      className: "FormGroup",
    },
    {
      label: "MARK",
      name: "mark",
      type: isDisabled ? "disable" : "select",
      options: markDataList?.map((ele) => {
        return { label: ele.markCode, value: ele.markId };
      }),
      required: false,
      className: "FormGroup",
    },
    {
      label: "Warehouse",
      name: "warehouse",
      type: isDisabled ? "disable" : "select",
      options: warehouseUserList?.map((ele) => {
        return { label: ele.wareHouseCode, value: ele.wareHouseUserRegId };
      }),
      required: false,
      className: "FormGroup",
    },
    {
      label: "Arrival Date",
      name: "arrivalDate",
      type: isDisabled ? "disable" : "datepicker",
      required: true,
      className: "FormGroup",
    },
    {
      label: "AWR Date",
      name: "awrdDate",
      type: isDisabled ? "disable" : "disableDatePicker",
      required: true,
      className: "FormGroup",
    },
    {
      label: "Catalog Closing Date",
      name: "catalogClosingDate",
      type: isDisabled ? "disable" : "disable",
      value: formik.values.catalogClosingDate,
      required: true,
      className: "FormGroup",
    },
    {
      label: "Invoice Date",
      name: "invoiceDate",
      type: isDisabled ? "disable" : "datepicker",
      required: true,
      className: "FormGroup",
    },
    {
      label: "Manufacture",
      name: "manufacture",
      type: isDisabled ? "disable" : "disable",
      value: formik.values.manufacture,
      required: false,
      className: "FormGroup",
    },
    {
      label: "Grade",
      name: "grade",
      type: isDisabled ? "disable" : "select",
      options: gradesList?.map((ele) => {
        return { label: ele.gradeCode, value: ele.gradeId };
      }),
      required: false,
      className: "FormGroup",
    },
  ];

  const handleButtonClick = () => {
    formik.handleReset();
    setHandleChnage(false); // Reset the "handleChange" flag as well

    fileInputRef.current.click();
  };
  const truncateToTwoDecimals = (value) => {
    return Math.round(value * 100) / 100;
  };
  const handleDownload = () => {
    let documentName = "SampleAwr.xlsx";

    axiosMain
      .post(
        `/preauction/${baseUrlEng}/DownloadAwrSampleExcel?role=` + roleCode,
        {
          auctionCenterId: auctionCenterId,
          Season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          auctioneerId: userId,
          markId: formik.values.mark === "" ? 0 : parseInt(formik.values.mark),
          wareHouseUserRegId:
            formik.values.warehouse === ""
              ? 0
              : parseInt(formik.values.warehouse),
          awrReferenceNo: formik.values.awrNo,
          grade: formik.values.grade === "" ? 0 : parseInt(formik.values.grade),
        }
        // rows?.map((ele) => {
        //   return { LotNo: ele.LotNo };
        // })
      )
      .then((res) => {
        let documentBytes = res?.data?.responseData[0]?.byteDatas;

        // Decode base64 encoded documentBytes
        const decodedBytes = atob(documentBytes);

        // Create a Blob from the decoded bytes
        const blob = new Blob([
          new Uint8Array([...decodedBytes].map((char) => char.charCodeAt(0))),
        ]);

        // Create an object URL from the Blob
        const blobUrl = URL.createObjectURL(blob);

        // Create a hidden anchor element
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = blobUrl;
        anchor.download = documentName;

        // Append anchor to the body
        document.body.appendChild(anchor);

        // Programmatically click the anchor element
        anchor.click();

        // Clean up: remove the anchor and revoke the object URL
        document.body.removeChild(anchor);
        URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => console.log(err));
  };
  const handleFileUpload = async (e) => {
    openLoader();
    const files = e.target.files;
    const file = e.target.files[0];
    let count = 0;
    let boolcheckAllColumn;

    try {
      const newpropchng = propertyNameList.map((ele) => {
        if (ele.title === "Manufacture From Date") {
          return { ...ele, title: "Period of Manufacture From" };
        } else if (ele.title === "Manufacture To Date") {
          return { ...ele, title: "Period of Manufacture To" };
        } else if (ele.title === "Warehouse Unit Short Name") {
          return { ...ele, title: "Warehouse Code" };
        } else if (ele.title === "Lorry Receipt Number") {
          return { ...ele, title: "Lorry Receipt No" };
        } else if (ele.title === "Lorry Number") {
          return { ...ele, title: "Lorry No" };
        } else if (ele.title === "Invoice Number") {
          return { ...ele, title: "Inv. No" };
        } else if (ele.title === "Sub Tea Type") {
          return { ...ele, title: "Sub Type" };
        } else if (ele.title === "Package Number") {
          return { ...ele, title: "Package Nos" };
        } else if (ele.title === "GP Number") {
          return { ...ele, title: "GP No" };
        } else if (ele.title === "Short Excess Weight") {
          return { ...ele, title: "Short/Excess Weight" };
        } else if (ele.title === "Location Inside Warehouse") {
          return { ...ele, title: "Location inside Warehouse" };
        } else if (ele.title === "AWR Reference Number") {
          return { ...ele, title: "AWR Ref No" };
        } else return ele;
      });
      const newcolu = newpropchng.push({
        name: "Auctioneer",
        title: "Auctioneer Code",
      });

      boolcheckAllColumn = await checkAllcoulm(file, newpropchng);

      // Use vbool as needed
    } catch (error) {
      console.error("Error checking columns:", error);
    }

    for (const file of files) {
      const fileSize = file.size;
      const fileName = file.name;
      const fileExtension = fileName.slice(
        ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
      );

      if (!ALLOWED_EXTENSIONS.includes("." + fileExtension.toLowerCase())) {
        CustomToast.error(`Only Excel files are allowed.`);
      } else if (fileSize <= 0) {
        CustomToast.error(`File with 0 KB size is not allowed.`);
        return Promise.resolve(null);
        return false;
      } else if (fileSize > MAX_FILE_SIZE) {
        CustomToast.error(`The file size should not exceed 10MB`);
      } else {
        if (boolcheckAllColumn) {
          count = count + 1;
          const promises = Array.from(files).map((file) =>
            readFileAndCheckHeaders(file)
          );

          Promise.allSettled(promises).then((results) => {
            const fulfilledResults = results.filter(
              (result) => result.status === "fulfilled"
            );
            const dataFromFiles = fulfilledResults.map(
              (result) => result.value
            );
            if (dataFromFiles.length === count) {
              handleData(dataFromFiles);
            }
          });
        }
      }
    }
  };

  const handleFileRemove = (index) => {
    setUploadedFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };
  const propertyName = [
    "inspectionchgs",
    "lotno",
    "packageno",
    "reinspectionchgs",
    "samplewt",
    "shortwt",
  ];

  function fixKeyNames(obj) {
    const newObj = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        let fixedKey = key.replace("/", "_"); // Replace '/' with '_'
        fixedKey = fixedKey.replace(".No", "No");
        fixedKey = fixedKey.replace("a.e.d", "AED");
        newObj[fixedKey] = obj[key];
      }
    }

    return newObj;
  }

  // function excelDateToJSDate(excelDate) {
  //   console.log(excelDate,"excelDate")
  //   const MS_PER_DAY = 24 * 60 * 60 * 1000; // Milliseconds per day
  //   const excelStartDate = new Date(1900, 0, 1); // Excel date system starts from January 1, 1900
  //   const excelDays = excelDate - 1; // Excel date is 1-based

  //   const jsTimestamp = excelStartDate.getTime() + excelDays * MS_PER_DAY;
  //   const jsDate = new Date(jsTimestamp);

  //   const day = jsDate.getDate().toString().padStart(2, "0");
  //   const month = (jsDate.getMonth() + 1).toString().padStart(2, "0");
  //   const year = jsDate.getFullYear();

  //   return `${year}-${month}-${day}`;
  // }
  // function excelDateToJSDate(excelDate) {
  //   const MS_PER_DAY = 24 * 60 * 60 * 1000; // Milliseconds per day
  //   const excelStartDate = new Date(1899, 11, 30); // Adjusted start date (Excel epoch is one day ahead)
  //   const excelDays = excelDate; // Excel date is 1-based

  //   const jsTimestamp = excelStartDate.getTime() + excelDays * MS_PER_DAY;
  //   const jsDate = new Date(jsTimestamp);

  //   const day = jsDate.getDate().toString().padStart(2, "0");
  //   const month = (jsDate.getMonth() + 1).toString().padStart(2, "0");
  //   const year = jsDate.getFullYear();

  //   return isNaN(year) ? "" : `${year}-${month}-${day}`;
  // }
  function excelDateToJSDate(excelDate) {
    if (excelDate !== undefined) {
      const MS_PER_DAY = 24 * 60 * 60 * 1000; // Milliseconds per day
      const excelStartDate = new Date(1899, 11, 30); // Excel's incorrect leap year handling
      if (typeof excelDate === "number") {
        const excelDays = excelDate; // Excel date is 1-based

        const jsTimestamp = excelStartDate.getTime() + excelDays * MS_PER_DAY;
        const jsDate = new Date(jsTimestamp);

        const day = jsDate.getDate().toString().padStart(2, "0");
        const month = (jsDate.getMonth() + 1).toString().padStart(2, "0");
        const year = jsDate.getFullYear();

        return isNaN(year) ? "" : `${year}-${month}-${day}`;
      } else if (typeof excelDate === "string" && excelDate.includes("/")) {
        const [day, month, year] = excelDate.split("/").map(Number);

        // Format the date as "YYYY-MM-DD"
        const formattedDate = `${year}-${month
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

        // Create a JavaScript Date object using the formatted date
        // const jsDate = new Date(formattedDate);

        // // Calculate the Excel date by subtracting the start date and dividing by milliseconds per day
        // const excelDays = (jsDate.getTime() - excelStartDate.getTime()) / MS_PER_DAY + 1;
        return formattedDate;
      } else if (typeof excelDate === "string" && excelDate.includes("-")) {
        const [day, month, year] = excelDate.split("-").map(Number);

        // Format the date as "YYYY-MM-DD"
        const formattedDate = `${year}-${month
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

        // Create a JavaScript Date object using the formatted date
        // const jsDate = new Date(formattedDate);

        // // Calculate the Excel date by subtracting the start date and dividing by milliseconds per day
        // const excelDays = (jsDate.getTime() - excelStartDate.getTime()) / MS_PER_DAY + 1;
        return formattedDate;
      } else {
        return ""; // Invalid input format
      }
    } else return "";
  }

  function netKagesCalculation(gross, tare) {
    if (gross > tare) {
      // return (gross - tare).toFixed(2);
      // return (gross - tare);
      return truncateToTwoDecimals(
        ((isNaN(gross) ? 0 : gross) - (isNaN(tare) ? 0 : tare)).toFixed("2")
      );
    } else
      return truncateToTwoDecimals(
        ((isNaN(gross) ? 0 : gross) - (isNaN(tare) ? 0 : tare)).toFixed("2")
      );
    // else {
    //   CustomToast.error(
    //     "Tare KGs cannot be greater than or equal to Gross KGs"
    //   );
    // }
  }
  const totalPackagesCalculation = (pkgNo) => {
    const firstValue = parseInt(pkgNo?.split("-")[0]);
    const secondValue = parseInt(pkgNo?.split("-")[1]);
    console.log(pkgNo, firstValue - secondValue, "pkgNopkgNo");
    if (firstValue > secondValue) {
      //CustomToast.error("package from has to be greater than package to.");
      return false;
    } else {
      let result = secondValue - firstValue;
      if (result + 1 <= 0) {
        // CustomToast.error("package from has to be greater than zero.");
        return false;
      } else {
        return result + 1;
      }
    }
  };
  function totalNetKagesCalculation(totalPackage, netKags, sampleQty) {
    const result = totalPackage * netKags;

    return truncateToTwoDecimals(result - sampleQty)?.toFixed(2);
  }
  const handleData = async (uploadedData) => {
    try {
      const updatedFileData = [];
      // if (fileData.length > 0) {
      uploadedData.map(({ fileName, data }, index) => {
        if (data && data.length > 0) {
          const filteredData = data.filter((obj) => {
            // Check if any key in the object has a defined value
            return Object.values(obj).some((value) => value !== undefined);
          });
          // //debugger;
          const dataList =
            // auction !== "ENGLISH"
            //   ?
            filteredData.map((ele) => {
              const {
                arrivalDate,
                auctioneerCode,
                awrDate,
                carrier,
                category,
                dateOfDispatch,
                gpDate,
                gpNo,
                grade,
                grossKgs,
                invNo,
                cess,
                dutyPayable,
                basic_AED,
                invoiceDate,
                locationInsideWarehouse,
                lorryNo,
                lorryReceiptNo,
                mark,
                netKgs,
                packageNos,
                packageSize,
                packageType,
                periodOfManufactureFrom,
                periodOfManufactureTo,
                saleNo,
                season,
                subType,
                tareKgs,
                teaType,
                // auctioneerCode,
                totalNetKgs,
                totalPackages,
                warehouseAddress,
                short_excessWeight,
                warehouseCode,
                warehouseName,
                awrRefNo,
              } = fixKeyNames(ele);

              let data = {
                markId: 0,
                season: season === undefined ? "" : season?.toString()?.trim(),
                teaTypeId: 0,
                saleNo: parseInt(saleNo),
                SaleProgramId: "",
                wareHouseUnitId: 0,
                auctioneerId: userId, //auctioner
                categoryId: 0,
                manufactureFromDate: excelDateToJSDate(periodOfManufactureFrom),
                manufactureToDate: excelDateToJSDate(periodOfManufactureTo),
                dateOfDispatch: excelDateToJSDate(dateOfDispatch),
                invoiceDate: excelDateToJSDate(invoiceDate),
                carrier:
                  carrier === undefined || carrier === ""
                    ? ""
                    : carrier?.toString()?.trim(),
                lorryReceiptNo:
                  lorryReceiptNo === undefined || lorryReceiptNo === ""
                    ? ""
                    : lorryReceiptNo?.toString()?.trim(),
                lorryNo:
                  lorryNo === undefined || lorryNo === ""
                    ? ""
                    : lorryNo?.toString()?.trim(),
                invoiceNo: invNo === undefined ? "" : invNo?.toString()?.trim(),
                cess:
                  cess === null || cess === undefined
                    ? 0
                    : cess?.toString()?.trim(),
                dutyPayable:
                  dutyPayable === null || dutyPayable === undefined
                    ? 0
                    : dutyPayable?.toString()?.trim(),
                basic_AED:
                  basic_AED === null || basic_AED === undefined
                    ? 0
                    : basic_AED?.toString()?.trim(),
                arrivalDate: excelDateToJSDate(arrivalDate),
                awrDate: excelDateToJSDate(awrDate),
                awrReferenceNo:
                  awrRefNo === null || awrRefNo === undefined
                    ? ""
                    : awrRefNo?.toString()?.trim(),
                subTeaTypeId: 0,
                gradeId: 0,
                // parseInt(grade) === 0
                //   ? gradesList?.at(0)?.gradeId
                //   : parseInt(grade),
                packageType:
                  packageType === undefined || packageType === ""
                    ? ""
                    : packageType.toString(),
                packageSize:
                  packageSize === undefined || packageSize === ""
                    ? ""
                    : packageSize.toString(),
                packageNo:
                  packageNos === undefined ? "" : packageNos.toString().trim(),
                totalPackages: totalPackagesCalculation(
                  packageNos === undefined ? "" : packageNos.toString()
                ),
                grossKgs: parseFloat(
                  truncateToTwoDecimals(grossKgs)?.toFixed("2")
                ),
                tareKgs: parseFloat(
                  truncateToTwoDecimals(tareKgs)?.toFixed("2")
                ),
                netKgs: netKagesCalculation(
                  grossKgs === undefined
                    ? 0
                    : parseFloat(
                        parseFloat(
                          truncateToTwoDecimals(grossKgs)?.toFixed("2")
                        )?.toFixed("2")
                      ),
                  tareKgs === undefined
                    ? 0
                    : parseFloat(
                        parseFloat(
                          truncateToTwoDecimals(tareKgs)?.toFixed("2")
                        )?.toFixed("2")
                      )
                ),
                totalNetKgs: totalNetKagesCalculation(
                  totalPackagesCalculation(
                    packageNos === undefined ? "" : packageNos.toString()
                  ),
                  netKagesCalculation(
                    grossKgs === undefined
                      ? 0
                      : parseFloat(
                          truncateToTwoDecimals(grossKgs)?.toFixed("2")
                        ),
                    tareKgs === undefined
                      ? 0
                      : parseFloat(truncateToTwoDecimals(tareKgs)?.toFixed("2"))
                  ),
                  short_excessWeight === null ||
                    short_excessWeight === undefined
                    ? 0
                    : parseFloat(
                        truncateToTwoDecimals(short_excessWeight)?.toFixed("2")
                      )
                ),
                invoiceQty: totalNetKagesCalculation(
                  totalPackagesCalculation(
                    packageNos === undefined ? "" : packageNos.toString()
                  ),
                  netKagesCalculation(
                    grossKgs === undefined
                      ? 0
                      : parseFloat(
                          truncateToTwoDecimals(grossKgs)?.toFixed("2")
                        ),
                    tareKgs === undefined
                      ? 0
                      : parseFloat(truncateToTwoDecimals(tareKgs)?.toFixed("2"))
                  ),
                  short_excessWeight === null ||
                    short_excessWeight === undefined
                    ? 0
                    : parseFloat(
                        truncateToTwoDecimals(short_excessWeight)?.toFixed("2")
                      )
                ),
                gpNo:
                  gpNo === "" || gpNo === undefined
                    ? ""
                    : Number.isInteger(gpNo)
                    ? parseInt(gpNo)
                    : typeof gpNo === "number"
                    ? parseFloat(gpNo)
                    : gpNo,
                gpDate: excelDateToJSDate(gpDate),
                shortExcessWeight: short_excessWeight,
                locationInsideWarehouse:
                  locationInsideWarehouse === undefined ||
                  locationInsideWarehouse === ""
                    ? ""
                    : locationInsideWarehouse.toString(),
                isActive: true,
                createdBy: userId, //auctioner
                updatedBy: userId, //auctioner
                SampleQty: 0,
                DataFlag: "Excel",
                TeaType: teaType,
                Category: category,
                Grade: grade === undefined ? "" : grade.toString(),
                Mark: mark,
                SubTeaType: subType,
                Warehouse: warehouseCode,
                Auctioneer: auctioneerCode,
                auctionCenterId: auctionCenterId,
              };

              return data;
            });
          // : filteredData.map((ele) => {
          //     const {
          //       arrivalDate,
          //       auctioneerCode,
          //       awrDate,
          //       carrier,
          //       category,
          //       dateOfDispatch,
          //       gpDate,
          //       gpNo,
          //       grade,
          //       grossKgs,
          //       invNo,
          //       invoiceDate,
          //       locationInsideWarehouse,
          //       lorryNo,
          //       lorryReceiptNo,
          //       mark,
          //       netKgs,
          //       packageNos,
          //       packageSize,
          //       packageType,
          //       periodOfManufactureFrom,
          //       periodOfManufactureTo,
          //       saleNo,
          //       season,
          //       subType,
          //       tareKgs,
          //       teaType,
          //       // auctioneerCode,
          //       totalNetKgs,
          //       totalPackages,
          //       warehouseAddress,
          //       short_excessWeight,
          //       warehouseCode,
          //       warehouseName,
          //     } = fixKeyNames(ele);

          //     let data = {
          //       markId: 0,
          //       season:
          //         season === undefined ? "" : season?.toString()?.trim(),
          //       teaTypeId: 0,
          //       saleNo: parseInt(saleNo),
          //       SaleProgramId: "",
          //       wareHouseUnitId: 0,
          //       auctioneerId: userId, //auctioner
          //       categoryId: 0,
          //       manufactureFromDate: excelDateToJSDate(
          //         periodOfManufactureFrom
          //       ),
          //       manufactureToDate: excelDateToJSDate(periodOfManufactureTo),
          //       dateOfDispatch: excelDateToJSDate(dateOfDispatch),
          //       invoiceDate: excelDateToJSDate(invoiceDate),
          //       carrier:
          //         carrier === undefined || carrier === ""
          //           ? ""
          //           : carrier?.toString()?.trim(),
          //       lorryReceiptNo:
          //         lorryReceiptNo === undefined || lorryReceiptNo === ""
          //           ? ""
          //           : lorryReceiptNo?.toString()?.trim(),
          //       lorryNo:
          //         lorryNo === undefined || lorryNo === ""
          //           ? ""
          //           : lorryNo?.toString()?.trim(),
          //       invoiceNo: invNo === undefined ? "" : invNo.toString(),
          //       arrivalDate: excelDateToJSDate(arrivalDate),
          //       awrDate: excelDateToJSDate(awrDate),
          //       awrReferenceNo: null,
          //       subTeaTypeId: 0,
          //       gradeId: 0,
          //       // parseInt(grade) === 0
          //       //   ? gradesList?.at(0)?.gradeId
          //       //   : parseInt(grade),
          //       packageType:
          //         packageType === undefined || packageType === ""
          //           ? ""
          //           : packageType.toString(),
          //       packageSize:
          //         packageSize === undefined || packageSize === ""
          //           ? ""
          //           : packageSize.toString(),
          //       packageNo:
          //         packageNos === undefined
          //           ? ""
          //           : packageNos.toString().trim(),
          //       totalPackages: totalPackagesCalculation(
          //         packageNos === undefined ? "" : packageNos.toString()
          //       ),
          //       grossKgs: parseFloat(
          //         truncateToTwoDecimals(grossKgs)?.toFixed("2")
          //       ),
          //       tareKgs: parseFloat(
          //         truncateToTwoDecimals(tareKgs)?.toFixed("2")
          //       ),
          //       netKgs: netKagesCalculation(
          //         grossKgs === undefined
          //           ? 0
          //           : parseFloat(
          //               parseFloat(
          //                 truncateToTwoDecimals(grossKgs)?.toFixed("2")
          //               )?.toFixed("2")
          //             ),
          //         tareKgs === undefined
          //           ? 0
          //           : parseFloat(
          //               parseFloat(
          //                 truncateToTwoDecimals(tareKgs)?.toFixed("2")
          //               )?.toFixed("2")
          //             )
          //       ),
          //       totalNetKgs: totalNetKagesCalculation(
          //         totalPackagesCalculation(
          //           packageNos === undefined ? "" : packageNos.toString()
          //         ),
          //         netKagesCalculation(
          //           grossKgs === undefined
          //             ? 0
          //             : parseFloat(
          //                 truncateToTwoDecimals(grossKgs)?.toFixed("2")
          //               ),
          //           tareKgs === undefined
          //             ? 0
          //             : parseFloat(
          //                 truncateToTwoDecimals(tareKgs)?.toFixed("2")
          //               )
          //         ),
          //         short_excessWeight === null ||
          //           short_excessWeight === undefined
          //           ? 0
          //           : parseFloat(
          //               truncateToTwoDecimals(short_excessWeight)?.toFixed(
          //                 "2"
          //               )
          //             )
          //       ),
          //       invoiceQty: totalNetKagesCalculation(
          //         totalPackagesCalculation(
          //           packageNos === undefined ? "" : packageNos.toString()
          //         ),
          //         netKagesCalculation(
          //           grossKgs === undefined
          //             ? 0
          //             : parseFloat(
          //                 truncateToTwoDecimals(grossKgs)?.toFixed("2")
          //               ),
          //           tareKgs === undefined
          //             ? 0
          //             : parseFloat(
          //                 truncateToTwoDecimals(tareKgs)?.toFixed("2")
          //               )
          //         ),
          //         short_excessWeight === null ||
          //           short_excessWeight === undefined
          //           ? 0
          //           : parseFloat(
          //               truncateToTwoDecimals(short_excessWeight)?.toFixed(
          //                 "2"
          //               )
          //             )
          //       ),
          //       gpNo:
          //         gpNo === "" || gpNo === undefined
          //           ? ""
          //           : Number.isInteger(gpNo)
          //           ? parseInt(gpNo)
          //           : typeof gpNo === "number"
          //           ? parseFloat(gpNo)
          //           : gpNo,
          //       gpDate: excelDateToJSDate(gpDate),
          //       shortExcessWeight: short_excessWeight,
          //       locationInsideWarehouse:
          //         locationInsideWarehouse === undefined ||
          //         locationInsideWarehouse === ""
          //           ? ""
          //           : locationInsideWarehouse.toString(),
          //       isActive: true,
          //       createdBy: userId, //auctioner
          //       updatedBy: userId, //auctioner
          //       SampleQty: 0,
          //       DataFlag: "Excel",
          //       TeaType: teaType,
          //       Category: category,
          //       Grade: grade === undefined ? "" : grade.toString(),
          //       Mark: mark,
          //       SubTeaType: subType,
          //       Warehouse: warehouseCode,
          //       Auctioneer: auctioneerCode,
          //       auctionCenterId: auctionCenterId,
          //     };

          //     return data;
          //   });

          // if (
          //   dataList
          //     .map(
          //       (ele) =>
          //         // Number.isInteger(ele.gpNo) === true)
          //         (typeof ele.gpNo === "number") === true
          //     )
          //     .includes(false)
          // ) {
          //   CustomToast.error("Please enter valid GP NO.");
          // } else {
          //   if (dataList.some((ele) => ele.gpDate !== "")) {
          //     updatedFileData.push(dataList);
          //   } else {
          //     CustomToast.error("Please enter valid GP Date.");
          //   }
          // }
          updatedFileData.push(dataList);
          // updatedFileData.push(filteredData);
        } else {
          // Handle the case where the data array is empty
          CustomToast.error(`No data found in file '${fileName}'`);
        }
      });
      // } else {
      //   CustomToast.error(`No file found in fields`);
      // }
      const mergedArray = updatedFileData.reduce((result, currentArray) => {
        return result.concat(currentArray);
      }, []);
      console.log(updatedFileData?.at(0), "updatedFileData");

      allData(mergedArray);
    } catch (error) {
      CustomToast.error(error);
    }
    // validation(uploadedData);
  };

  const allData = (dataList) => {
    if (dataList.length > 0) {
      setFileData([]);
      const apiUrl = `/preauction/Common/GetSaleProgramDetailBySaleNo`;

      // Data to be sent in the POST request

      // Making the POST request using Axios

      // } else {
      if (
        dataList?.at(0)?.saleNo !== undefined &&
        dataList?.at(0)?.saleNo !== "" &&
        !isNaN(dataList?.at(0)?.saleNo)
      ) {
        axiosMain
          .post(apiUrl, {
            saleNo: parseInt(dataList?.at(0)?.saleNo),
            season: dataList?.at(0)?.season.toString(),
            auctionCenterId: auctionCenterId,
          })
          .then((response) => {
            closeLoader();
            if (response.data.statusCode === 200) {
              // item.SaleProgramId = ;
              if (fileData?.length > 0) {
                setFileData([
                  ...fileData,
                  ...dataList.map((ele) => ({
                    ...ele,
                    gpNo: String(ele.gpNo || ""),
                    SaleProgramId:
                      response?.data?.responseData[0]?.SaleProgramId,
                  })),
                ]);
              } else {
                setFileData([
                  ...dataList.map((ele) => ({
                    ...ele,
                    gpNo: String(ele.gpNo || ""),
                    SaleProgramId:
                      response?.data?.responseData[0]?.SaleProgramId,
                  })),
                ]);
              }
              setIsNotCurrectSaleNo("");
            } else if (response.data.statusCode === 403) {
              setFileData([
                ...dataList.map((ele) => ({
                  ...ele,
                  gpNo: String(ele.gpNo || ""),
                  SaleProgramId: null,
                })),
              ]);
              setIsNotCurrectSaleNo(response.data.message);
            } else {
              setFileData([
                ...dataList.map((ele) => ({
                  ...ele,
                  gpNo: String(ele.gpNo || ""),
                  SaleProgramId: null,
                })),
              ]);
              setIsNotCurrectSaleNo("");
            }
            setbaseUrlEng(
              response?.data?.responseData[0]?.auctionTypeCode === "BHARAT"
                ? "AWRDetails"
                : "EnglishAuctionAWRDetails"
            );
            setCatalogclosingDate(
              response?.data?.responseData[0]?.catalogClosingDate?.split("T")[0]
            );
            // Handle the API response here
            // setsaleprogrmId();
            // console.log(
            //   dataList.filter(
            //     (ele) =>
            //     (ele.SaleProgramId =
            //       response?.data?.responseData[0]?.SaleProgramId)
            // ),
            //   "response?.data?.responseData[0]?.SaleProgramId"
            // );

            // let data = dataList.filter(
            //   (ele) =>
            //     (ele.SaleProgramId =
            //
            // );

            // item.SaleProgramId = ;
            // if (fileData?.length > 0) {
            //   setFileData([
            //     ...fileData,
            //     ...dataList.map((ele) => ({
            //       ...ele,
            //       SaleProgramId: response?.data?.responseData[0]?.SaleProgramId,
            //     })),
            //   ]);
            // } else {
            //   setFileData([
            //     ...dataList.map((ele) => ({
            //       ...ele,
            //       SaleProgramId: response?.data?.responseData[0]?.SaleProgramId,
            //     })),
            //   ]);
            // }
            // console.log(
            //   response?.data?.responseData[0]?.SaleProgramId,
            //   "response?.data?.responseData[0]?.SaleProgramId)"
            // );
            // document.getElementById("file-upload").value = "";
          })
          .catch((error) => {
            // Handle errors here
            console.log(error);
          });
        // const data = dataList.map((item) => {});

        // console.log(data, dataList, "dataF");
      } else {
        if (fileData?.length > 0) {
          setFileData([
            ...fileData,
            ...dataList.map((ele) => ({
              ...ele,
              gpNo: String(ele.gpNo || ""),
              SaleProgramId: 0,
            })),
          ]);
        } else {
          setFileData([
            ...dataList.map((ele) => ({
              ...ele,
              gpNo: String(ele.gpNo || ""),
              SaleProgramId: 0,
            })),
          ]);
        }
      }
      // }
    }
  };

  const validation = async (uploadedData) => {
    const updatedFileData = [];
    if (fileData.length > 0) {
      for (const { fileName, data } of uploadedData) {
        if (data && data.length > 0) {
          const missingProperties = propertyName.filter((propertyName) => {
            return !data.some((obj) => propertyName in obj);
          });

          const filteredData = data.filter((obj) => {
            // Check if any key in the object has a defined value
            return Object.values(obj).some((value) => value !== undefined);
          });

          if (missingProperties.length === 0 && filteredData.length > 0) {
            // console.log(`All properties are present in file '${fileName}'`);
            CustomToast.success(
              `All properties are present in file ${fileName}`
            );
            updatedFileData.push(filteredData);
            // Continue with processing the data
            // ... rest of your code ...
          } else {
            // console.log(
            //   `Missing properties in file '${fileName}':`,
            //   missingProperties
            // );

            // Handle the case where properties are missing
            CustomToast.error(
              `Missing properties in file '${fileName}': ${missingProperties.join(
                ", "
              )}`
            );
          }
        } else {
          // Handle the case where the data array is empty
          CustomToast.error(`No data found in file '${fileName}'`);
        }
      }
    } else {
      CustomToast.error(`No file found in fields`);
    }
    const mergedArray = updatedFileData.reduce((result, currentArray) => {
      return result.concat(currentArray);
    }, []);
    // console.log(mergedArray, "updatedFileData");

    setValidationData([...sampleList, ...mergedArray]);
  };

  const handleAddData = () => {
    // You can call this function when the "Add Data" button is clicked

    const fileInput = document.getElementById("fileInput");

    if (fileData?.length > 0 && validationData?.length > 0) {
      // handleData(/* Your uploaded data here */);
      fileInput.value = "";
      setSampleList(validationData);
      setFileData([]);
      CustomToast.success("Data added successfully!");
    } else {
      CustomToast.error("Data validation failed! Cannot add data.");
    }
  };

  function findDuplicateInvoiceNumbers(arrayOfObjects) {
    const invoiceNumbers = new Map();
    const duplicateInvoices = [];

    arrayOfObjects.forEach((obj) => {
      if (invoiceNumbers.has(obj.invoiceNo)) {
        duplicateInvoices.push(obj.invoiceNo);
      }
      invoiceNumbers.set(obj.invoiceNo, true);
    });

    return duplicateInvoices;
  }

  const propertyNames = [
    {
      name: "markId",
      title: "Mark",
      getCellValue: ({ ...row }) => (
        <span>
          {markDataList?.map((ele) =>
            ele.markId == row?.markId ? ele.markName : ""
          )}
        </span>
      ),
    },
    { name: "season", title: "Season" },
    {
      name: "teaType",
      title: "Tea Type ID",
      getCellValue: ({ ...row }) => (
        <span>
          {teaTypeList?.map((ele) =>
            ele.teaTypeId == row?.teaTypeId ? ele.teaTypeName : ""
          )}
        </span>
      ),
    },
    { name: "saleNo", title: "Sale No" },
    { name: "wareHouseUserRegId", title: "Warehouse User Registration ID" },
    // { name: "auctioneerId", title: "Auctioneer ID" },
    { name: "categoryId", title: "Category" },
    { name: "manufactureFromDate", title: "Manufacture From Date" },
    { name: "manufactureToDate", title: "Manufacture To Date" },
    { name: "dateOfDispatch", title: "Date of Dispatch" },
    { name: "invoiceDate", title: "Invoice Date" },
    { name: "carrier", title: "Carrier" },
    { name: "lorryReceiptNo", title: "Lorry Receipt Number" },
    { name: "lorryNo", title: "Lorry Number" },
    { name: "invoiceNo", title: "Invoice Number" },
    { name: "arrivalDate", title: "Arrival Date" },
    { name: "awrDate", title: "AWR Date" },
    { name: "awrReferenceNo", title: "AWR Reference Number" },
    { name: "subTeaTypeId", title: "Sub Tea Type" },
    { name: "gradeId", title: "Grade" },
    { name: "packageType", title: "Package Type" },
    { name: "packageSize", title: "Package Size" },
    { name: "packageNo", title: "Package Number" },
    { name: "totalPackages", title: "Total Packages" },
    { name: "grossKgs", title: "Gross Kgs" },
    { name: "tareKgs", title: "Tare Kgs" },
    { name: "netKgs", title: "Net Kgs" },
    { name: "totalNetKgs", title: "Total Net Kgs" },
    { name: "gpNo", title: "GP Number" },
    { name: "gpDate", title: "GP Date" },
    { name: "shortExcessWeight", title: "Short Excess Weight" },
    { name: "locationInsideWarehouse", title: "Location Inside Warehouse" },
    // {
    //   name: "isActive",
    //   title: "Is Active",
    //   getCellValue: ({ ...row }) => (
    //     <span>{row.isActive == true ? "true" : "false"}</span>
    //   ),
    // },
    // { name: "createdBy", title: "Created By" },
    { name: "invoiceQty", title: "Invoice Qty" },
    {
      name: "action",
      title: "Action",
      getCellValue: ({ ...row }) => <ActionArea data={row} />,
    },
  ];

  const handleInputChange = (event, index, field) => {
    const newData = [...tableData];
    newData[index][field] = event.target.value;
    setTableData(newData);
  };

  const ActionArea = (row) => {
    // const indexs = invoiceData.indexOf(row.data.SaleProgramId);

    return (
      <>
        {/* <button
          style={{ background: "transparent", border: "none", color: "green" }}
          onClick={() => {
            // handleAction("edit");
            formik.setValues(row.data);
          }}
        >
          <EditIcon />
        </button> */}
        <button
          className="action-btn"
          onClick={() => {
            // console.log(indexs, row.data, "invData");
            // setFileData(
            //   fileData.filter((ele) => ele.invoiceNo !== row.data.invoiceNo)
            // );
            console.log(fileData, tableData, row, "invData");
          }}
        >
          <DeleteIcon />
        </button>
      </>
    );
  };
  const showcheckboxlebels = [
    {
      title: "tea Type",
      name: "teaType",
    },
    {
      title: "sub Type",
      name: "subType",
    },
    {
      title: "category",
      name: "category",
    },
    {
      title: "grade",
      name: "grade",
    },
    {
      title: "package Size",
      name: "packageSize",
    },
    {
      title: "package Type",
      name: "packageType",
    },
    {
      title: "package No",
      name: "packageNo",
    },
    {
      title: "total Packages",
      name: "totalPackages",
    },
    {
      title: "gross Kgs",
      name: "grossKgs",
    },
    {
      title: "tare Kgs",
      title: "tareKgs",
    },
    {
      title: "net Kgs",
      name: "netKgs",
    },
    {
      title: "total Net Kgs",
      name: "totalNetKgs",
    },
  ];

  const handleExportToPdf = () => {
    // const sourceDiv = sourceDivRef.current;
    // // const targetDiv = targetDivRef.current;

    // if (sourceDiv) {
    //   const pdfOptions = { margin: 10, filename: "Invoice_Export.pdf" };

    //   html2pdf(sourceDiv, pdfOptions);
    //   // html2pdf(targetDiv, pdfOptions);
    // }
    // const markval = formik.values.mark;
    // const markvalselectedText = markDataList.filter((item) => item.markId === markval)?.at(0).markName;

    // const subteatypeval = formik.values.subType;
    // const subTypeselectedText = subTeaTypeNo.filter((item) => item.subTeaTypeId === subteatypeval)?.at(0).subTeaTypeName;

    // const teaTypeNameval = formik.values.teaType;
    // const teaTypeNameselectedText = teaTypeList.filter((item) => item.teatypeid === teaTypeNameval)?.at(0).teaTypeName;

    // const auctioneerval = formik.values.auctioneerId;
    // const auctioneerselectedText = auctioneer.filter((item) => item.userId === auctioneerval)?.at(0).userCode;

    const AwrPrintArr = Object.keys(tableData[0])
      .filter(
        (item) =>
          item === "gpDate" ||
          item === "gpNo" ||
          item === "invoiceNo" ||
          item === "Origin" ||
          item === "categoryName" ||
          item === "teaTypeName" ||
          item === "subTeaTypeName" ||
          item === "markName" ||
          item === "grossKgs" ||
          item === "tareKgs" ||
          item === "netKgs" ||
          item === "packageNo" ||
          item === "shortExcessWeight" ||
          item === "dateOfDispatch" ||
          item === "carrier" ||
          item === "lorryReceiptNo" ||
          item === "lorryNo"
      )
      .map((key) => {
        return {
          name: key,
          title: key.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase(), // Convert camelCase to Title Case
        };
      });
    setAwrPrintArr(AwrPrintArr);

    // var data = []
    // data?.push(formik.values);
    // var newobj = tableData?.map((item) => ({
    //   ...item
    // }))

    var newdat = tableData.map((obj) => {
      for (const key in obj) {
        if (obj[key] === undefined || obj[key] === null) {
          obj[key] = "";
        }
      }
      return obj;
    });
    setprintrow(newdat);
    console.log(formik, newdat, "newdatnewdat");
    setopenPrintModel(true);
  };
  function validateSeasonAndSaleNo(arr) {
    let firstSeason = arr[0].season;
    let firstSaleNo = arr[0].saleNo;

    let allSame = arr.every(
      (item) => item.season === firstSeason && item.saleNo === firstSaleNo
    );

    if (!allSame) {
      return "Validation: All seasons and sale numbers are not the same!";
    }

    return "All seasons and sale numbers are the same.";
  }

  function submitAwrDetails() {
    if (
      fileInputRef.current.value === "" ||
      fileInputRef.current.value === undefined ||
      fileInputRef.current.value === null
    ) {
      CustomToast.error("Please Select Excel file");
      return false;
    }
    if (fileData?.length > 0) {
      // if (validateSeasonAndSaleNo(fileData)) {
      //   CustomToast.error(
      //     "All records should have the same Season or Sale No. in a single sheet."
      //   );
      // }
      //REQ PARAM

      const checkarrivalDate = fileData
        ?.map(
          (ele) =>
            ele?.arrivalDate?.toString()?.trim() !== "" &&
            (ele?.arrivalDate?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
              ele.arrivalDate?.toString()?.trim()?.split(".")[1] === undefined)
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkGrossAndTeraKgs = fileData
        ?.map(
          (ele) =>
            ele?.grossKgs?.toString()?.trim() !== "" &&
            (ele?.grossKgs?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
              ele.grossKgs?.toString()?.trim()?.split(".")[1] === undefined)
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);
      const checkTeraKgs = fileData
        ?.map(
          (ele) =>
            ele?.tareKgs?.toString()?.trim() !== "" &&
            (ele?.tareKgs?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
              ele.tareKgs?.toString()?.trim()?.split(".")[1] === undefined)
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkMarks = fileData
        ?.map(
          (ele) =>
            ele?.Mark?.toString()?.trim() !== "" &&
            ele?.Mark?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkSeason = fileData
        ?.map(
          (ele) =>
            ele?.season?.toString()?.trim() !== "" &&
            ele?.season?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkSaleNo = fileData
        ?.map(
          (ele) =>
            ele?.saleNo?.toString()?.trim() !== "" &&
            ele?.saleNo?.toString()?.trim() !== undefined &&
            ele?.saleNo?.toString()?.trim() !== "NaN"
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkChLorryrecNo = fileData
        ?.map(
          (ele) =>
            ele?.lorryReceiptNo?.toString()?.trim() === "" ||
            ele?.lorryReceiptNo?.toString()?.trim() === undefined ||
            (ele?.lorryReceiptNo?.toString()?.trim() !== "" &&
              ele?.lorryReceiptNo?.toString()?.trim().length <= 25)
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkChLorryNo = fileData
        ?.map(
          (ele) =>
            ele?.lorryNo?.toString()?.trim() === "" ||
            ele?.lorryNo?.toString()?.trim() === undefined ||
            (ele?.lorryNo?.toString()?.trim() !== "" &&
              ele?.lorryNo?.toString()?.trim().length <= 25)
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkWarehouse = fileData
        ?.map(
          (ele) =>
            ele?.Warehouse?.toString()?.trim() !== "" &&
            ele?.Warehouse?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkAuctioneer = fileData
        ?.map(
          (ele) =>
            ele?.Auctioneer?.toString()?.trim() !== "" &&
            ele?.Auctioneer?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkinvoiceDate = fileData
        ?.map(
          (ele) =>
            ele?.invoiceDate?.toString()?.trim() !== "" &&
            ele?.invoiceDate?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkdateOfDispatch = fileData
        ?.map(
          (ele) =>
            ele?.dateOfDispatch?.toString()?.trim() !== "" &&
            ele?.dateOfDispatch?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);
      const checkgreatethanandlessthandateofdispatch =
        checkdateOfDispatch?.length > 0
          ? false
          : fileData
              ?.map(
                (ele) =>
                  ele?.dateOfDispatch !== "" &&
                  ele?.invoiceDate !== "" &&
                  new Date(ele.dateOfDispatch) >= new Date(ele.invoiceDate)
              )
              .map((ele, index) => ele === false && index + 1)
              .filter((ele) => ele !== false);

      const checkdateofdispatchbycatalogclosing =
        checkdateOfDispatch?.length > 0
          ? false
          : fileData
              ?.map(
                (ele) =>
                  ele?.dateOfDispatch !== "" &&
                  catalogclosedate !== "" &&
                  new Date(ele.dateOfDispatch) <= new Date(catalogclosedate)
              )
              .map((ele, index) => ele === false && index + 1)
              .filter((ele) => ele !== false);
      const checkinvoiceNo = fileData
        ?.map(
          (ele) =>
            ele?.invoiceNo?.toString()?.trim() !== "" &&
            ele?.invoiceNo?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkTeaType = fileData
        ?.map(
          (ele) =>
            ele?.TeaType?.toString()?.trim() !== "" &&
            ele?.TeaType?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkSubTeaType = fileData
        ?.map(
          (ele) =>
            ele?.SubTeaType?.toString()?.trim() !== "" &&
            ele?.SubTeaType?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkCategory = fileData
        ?.map(
          (ele) =>
            ele?.Category?.toString()?.trim() !== "" &&
            ele?.Category?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkGrade = fileData
        ?.map(
          (ele) =>
            ele?.Grade?.toString()?.trim() !== "" &&
            ele?.Grade?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkpackageType = fileData
        ?.map(
          (ele) =>
            ele?.packageType?.toString()?.trim() !== "" &&
            ele?.packageType?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkpackageNo = fileData
        ?.map(
          (ele) =>
            ele?.packageNo?.toString()?.trim() !== "" &&
            ele?.packageNo?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);
      // const checkgrossKgs = fileData
      //   ?.map(
      //     (ele) =>
      //       ele?.grossKgs?.toString()?.trim() !== "" &&
      //       ele?.grossKgs?.toString()?.trim() !== undefined &&
      //       !isNaN(ele.grossKgs)
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);
      const checkgrossKgs1 = fileData
        ?.map(
          (ele) =>
            ele?.grossKgs?.toString()?.trim() !== "" &&
            ele?.grossKgs?.toString()?.trim() !== undefined &&
            ele?.grossKgs?.toString()?.trim() !== "0" &&
            !isNaN(parseFloat(ele.grossKgs))
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);
      const chkgrosskgsnege = fileData
        ?.map(
          (ele) =>
            ele?.grossKgs?.toString()?.trim() !== "" &&
            ele?.grossKgs?.toString()?.trim() !== undefined &&
            ele?.grossKgs?.toString()?.trim() !== "0" &&
            ele?.grossKgs > 0
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);
      const checktareKgsnege = fileData
        ?.map(
          (ele) =>
            ele?.tareKgs?.toString()?.trim() !== "" &&
            ele?.tareKgs?.toString()?.trim() !== undefined &&
            ele?.tareKgs?.toString()?.trim() !== "0" &&
            ele?.tareKgs > 0
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checktareKgs = fileData
        ?.map(
          (ele) =>
            ele?.tareKgs?.toString()?.trim() !== "" &&
            ele?.tareKgs?.toString()?.trim() !== undefined &&
            !isNaN(parseFloat(ele?.tareKgs))
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checknetKgs = fileData
        ?.map(
          (ele) =>
            ele?.netKgs?.toString()?.trim() !== "" &&
            ele?.netKgs?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkawrDate = fileData
        ?.map(
          (ele) =>
            ele?.awrDate?.toString()?.trim() !== "" &&
            ele?.awrDate?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkgpDate = fileData
        ?.map(
          (ele) =>
            ele?.gpDate?.toString()?.trim() !== "" &&
            ele?.gpDate?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkgpNo = fileData
        ?.map(
          (ele) =>
            ele?.gpNo?.toString()?.trim() !== "" &&
            ele?.gpNo?.toString()?.trim() !== undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const rowInvalidGpNo = fileData
        .map((ele, index) => {
          if (ele.gpNo !== null && ele.gpNo !== "") {
            return /^[a-zA-Z0-9]+$/.test(ele.gpNo) ? null : index + 1;
          }
          return null; // Allow empty values
        })
        .filter((ele) => ele !== null); // Remove valid cases

      const checknetKgsnegetive = fileData
        ?.map(
          (ele) =>
            ele?.netKgs?.toString()?.trim() !== "" &&
            typeof ele?.netKgs === "number" &&
            ele?.netKgs > 0
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const decimalPattern = /^\d+\.\d+$/;
      const integerPattern = /^\d+$/;
      const checkcess = fileData
        ?.map(
          (ele) =>
            ele?.cess?.toString()?.trim() !== "" &&
            ele?.cess?.toString()?.trim() !== undefined
          // (!integerPattern.test(ele?.cess) || !decimalPattern.test(ele?.cess))
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const basic_AED = fileData
        ?.map(
          (ele) =>
            // ele?.basic_AED?.toString()?.trim() !== "" &&
            ele?.basic_AED?.toString()?.trim() !== undefined
          // (!integerPattern.test(ele?.cess) || !decimalPattern.test(ele?.cess))
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkdutyPayable = fileData
        ?.map(
          (ele) =>
            ele?.dutyPayable?.toString()?.trim() !== "" &&
            ele?.dutyPayable?.toString()?.trim() !== undefined
          // (!integerPattern.test(ele?.cess) || !decimalPattern.test(ele?.cess))
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      //END REQ PARAM
      // const toastMessages = fileData?.map((obj, index) => {
      //   let rowNo = index + 1;
      //   const fromDateParts =
      //     obj.manufactureFromDate.split("-");
      //   const toDateParts = obj.manufactureToDate.split("-");

      //   const fromDate =
      //     fromDateParts[2] +
      //     "-" +
      //     fromDateParts[1] +
      //     "-" +
      //     fromDateParts[0];
      //   const toDate =
      //     toDateParts[2] +
      //     "-" +
      //     toDateParts[1] +
      //     "-" +
      //     toDateParts[0];

      //   // console.log(
      //   //   obj.manufactureFromDate.split("-"),
      //   //   fromDateParts[2]+"-"+fromDateParts[1]+"-"+fromDateParts[0],
      //   //   new Date(toDate) >= new Date(fromDate),
      //   //   // fromDate,
      //   //   // obj.manufactureToDate,
      //   //   // toDate,
      //   //   "obj.manufactureFromDate,obj.manufactureToDate"
      //   // );

      //   const duplicates =
      //     findDuplicateInvoiceNumbers(fileData);

      //   // const isValid = validateMandatoryFields(
      //   //   invoiceData,
      //   //   propertyName
      //   // );

      //   if (duplicates.length > 0) {
      //     CustomToast.error(
      //       "Invoise No" +
      //         " " +
      //         duplicates.join(", ") +
      //         " " +
      //         "is already exist"
      //     );
      //     return false;
      //   } else if (
      //     obj.gpDate === null ||
      //     obj.gpNo === null ||
      //     obj.awrDate === null ||
      //     obj.arrivalDate === null
      //   ) {
      //     CustomToast.error(
      //       "Any AWR field is missing from gpdate,gpno,arrival date, awr date" +
      //         rowNo
      //     );
      //   } else {
      //     // console.log(
      //     //   toastMessages,
      //     //   "invoiceDatainvoiceDatainvoiceData"
      //     // );\

      //     return true;
      //   }
      // });
      // const toastMessages = fileData.map((obj, index) => {
      //   let rowNo = index + 1;
      //   const fromDateParts = obj.manufactureFromDate.split("-");
      //   const toDateParts = obj.manufactureToDate.split("-");

      //   const x = new Date(obj.manufactureFromDate);
      //   const y = new Date(obj.manufactureToDate);
      //   const fromDate =
      //     fromDateParts[2] + "-" + fromDateParts[1] + "-" + fromDateParts[0];
      //   const toDate =
      //     toDateParts[2] + "-" + toDateParts[1] + "-" + toDateParts[0];

      //   // console.log(
      //   //   obj.manufactureFromDate.split("-"),
      //   //   fromDateParts[2]+"-"+fromDateParts[1]+"-"+fromDateParts[0],
      //   //   new Date(toDate) >= new Date(fromDate),
      //   //   // fromDate,
      //   //   // obj.manufactureToDate,
      //   //   // toDate,
      //   //   "obj.manufactureFromDate,obj.manufactureToDate"
      //   // );

      //   // const isValid = validateMandatoryFields(
      //   //   invoiceData,
      //   //   propertyName
      //   // );
      //   if (y < x) {
      //     // //debugger;

      //     CustomToast.error(
      //       "Greater than or equal to From Date. Row No  " +
      //       toDate +
      //       "<" +
      //       fromDate +
      //       rowNo
      //     );
      //     return false;
      //   } else {
      //     return true;
      //   }
      // });

      // sedit
      // const duplicates = findDuplicateInvoiceNumbers(fileData);
      // if (duplicates.length > 0) {
      //   CustomToast.error(
      //     "Invoice No" + " " + duplicates.join(", ") + " " + "is already exist"
      //   );
      //   return false;
      // } else
      //debugger;

      const checkgraterthanlessfromtodate = fileData
        ?.map((ele, index) =>
          //   ele?.Mark?.toString()?.trim() !== "" &&
          //   ele?.Mark?.toString()?.trim() !== undefined
          {
            if (
              ele.manufactureFromDate !== "" ||
              ele.manufactureFromDate !== undefined ||
              ele.manufactureToDate !== "" ||
              ele.manufactureToDate !== undefined
            ) {
              const fromDateParts = ele.manufactureFromDate.split("-");
              const toDateParts = ele.manufactureToDate.split("-");
              const x = new Date(ele.manufactureFromDate);
              const y = new Date(ele.manufactureToDate);

              const fromDate =
                fromDateParts[2] +
                "-" +
                fromDateParts[1] +
                "-" +
                fromDateParts[0];
              const toDate =
                toDateParts[2] + "-" + toDateParts[1] + "-" + toDateParts[0];
              if (y < x) {
                return index + 1;
              } else {
                return 0;
              }
            }
          }
        )
        // .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== 0);

      if (checkMarks.length > 0) {
        CustomToast.error(
          "Please select/enter Mark in row no.  " + checkMarks?.join(",") + " "
        );
        return false;
      } else if (checkgraterthanlessfromtodate.length > 0) {
        CustomToast.error(
          "Manufacture To Date should be Greater than or equal to Manufacture From Date in Row No " +
            checkgraterthanlessfromtodate.join(",")
        );
        return false;
      } else if (checkSeason.length > 0) {
        CustomToast.error(
          "Please select/enter Season in row no.  " +
            checkSeason?.join(",") +
            " "
        );
        return false;
      } else if (
        fileData
          .map((ele) => !/^(19|20)\d{2}$/?.test(ele.season.toString()))
          ?.filter((ele) => ele !== false)?.length > 0
      ) {
        //debugger;
        CustomToast.error(
          "Please enter correct Season in row no." +
            fileData
              .map((ele, index) =>
                !/^(19|20)\d{2}$/?.test(ele.season.toString())
                  ? index + 1
                  : false
              )
              ?.filter((ele) => ele !== false)
              ?.join(",") +
            " "
        );
        return false;
      } else if (checkSaleNo.length > 0) {
        CustomToast.error(
          "Please select/enter Sale No in row no.  " +
            checkSaleNo?.join(",") +
            " "
        );
        return false;
      } else if (isNotCurrectSaleNo !== "") {
        CustomToast.error(isNotCurrectSaleNo);
        return false;
      } else if (
        fileData
          .map((ele) => !/^\d+$/?.test(ele.saleNo.toString()))
          ?.filter((ele) => ele !== false)?.length > 0
      ) {
        // //debugger;
        CustomToast.error(
          "Please enter correct SaleNo in row no." +
            fileData
              .map((ele, index) =>
                !/^\d+$/?.test(ele.saleNo.toString()) ? index + 1 : false
              )
              ?.filter((ele) => ele !== false)
              ?.join(",") +
            " "
        );
        return false;
      } else if (
        fileData.some(
          (ele, index) =>
            fileData[0].saleNo !== ele.saleNo ||
            fileData[0].season !== ele.season
        )
      ) {
        CustomToast.error(
          "All records should have the same Season or Sale No in a single sheet."
        );
        return false;
      } else if (checkWarehouse.length > 0) {
        CustomToast.error(
          "Please select/enter Warehouse code in row no.  " +
            checkWarehouse?.join(",") +
            " "
        );
        return false;
      } else if (checkChLorryrecNo.length > 0) {
        CustomToast.error(
          "Max length 25 numeric characters for  Lorry Receipt No. in row no. " +
            checkChLorryrecNo?.join(",") +
            " "
        );
        return false;
      } else if (checkAuctioneer.length > 0) {
        CustomToast.error(
          "Please select/enter Auctioner code in row no.  " +
            checkAuctioneer?.join(",") +
            " "
        );
        return false;
      } else if (checkinvoiceDate.length > 0) {
        CustomToast.error(
          "Please select/enter Invoice Date in row no.  " +
            checkinvoiceDate?.join(",") +
            " "
        );
        return false;
      } else if (checkcess.length > 0) {
        CustomToast.error(
          "Please select/enter Cess in row no.  " + checkcess?.join(",")
        );
        return false;
      } else if (
        fileData
          ?.map(
            (ele) =>
              ele?.cess?.toString()?.trim() !== "" &&
              ele?.cess?.toString()?.trim() !== undefined &&
              (integerPattern.test(ele?.cess) || decimalPattern.test(ele?.cess))
          )
          .map((ele, index) => ele === false && index + 1)
          .filter((ele) => ele !== false).length > 0
      ) {
        const checkcessNo = fileData
          ?.map(
            (ele) =>
              ele?.cess?.toString()?.trim() !== "" &&
              ele?.cess?.toString()?.trim() !== undefined &&
              (integerPattern.test(ele?.cess) || decimalPattern.test(ele?.cess))
          )
          .map((ele, index) => ele === false && index + 1)
          .filter((ele) => ele !== false);

        debugger;
        CustomToast.error(
          "Please enter appropriate Cess in row no.  " + checkcessNo?.join(",")
        );

        return false;
      } else if (basic_AED.length > 0) {
        CustomToast.error(
          "Please select/enter Basic A.E.D  in row no.  " + basic_AED?.join(",")
        );
        return false;
      } else if (
        fileData
          ?.map(
            (ele) =>
              ele?.basic_AED?.toString()?.trim() !== "" &&
              ele?.basic_AED?.toString()?.trim() !== undefined &&
              (integerPattern.test(ele?.basic_AED) ||
                decimalPattern.test(ele?.basic_AED))
          )
          .map((ele, index) => ele === false && index + 1)
          .filter((ele) => ele !== false).length > 0
      ) {
        const checkbasic_AEDNo = fileData
          ?.map(
            (ele) =>
              ele?.basic_AED?.toString()?.trim() !== "" &&
              ele?.basic_AED?.toString()?.trim() !== undefined &&
              (integerPattern.test(ele?.basic_AED) ||
                decimalPattern.test(ele?.basic_AED))
          )
          .map((ele, index) => ele === false && index + 1)
          .filter((ele) => ele !== false);

        debugger;
        CustomToast.error(
          "Please enter appropriate Basic A.E.D in row no.  " +
            checkbasic_AEDNo?.join(",")
        );
        return false;
      } else if (checkdutyPayable.length > 0 && auction !== "ENGLISH") {
        CustomToast.error(
          "Please select/enter Duty Payable in row no.  " +
            checkdutyPayable?.join(",")
        );
        return false;
      } else if (
        fileData
          ?.map(
            (ele) =>
              ele?.dutyPayable?.toString()?.trim() !== "" &&
              ele?.dutyPayable?.toString()?.trim() !== undefined &&
              (integerPattern.test(ele?.dutyPayable) ||
                decimalPattern.test(ele?.dutyPayable))
          )
          .map((ele, index) => ele === false && index + 1)
          .filter((ele) => ele !== false).length > 0
      ) {
        const checkdutyPayableNo = fileData
          ?.map(
            (ele) =>
              ele?.dutyPayable?.toString()?.trim() !== "" &&
              ele?.dutyPayable?.toString()?.trim() !== undefined &&
              (integerPattern.test(ele?.dutyPayable) ||
                decimalPattern.test(ele?.dutyPayable))
          )
          .map((ele, index) => ele === false && index + 1)
          .filter((ele) => ele !== false);

        // debugger;
        CustomToast.error(
          "Please enter appropriate Duty Payable in row no.  " +
            checkdutyPayableNo?.join(",")
        );
        return false;
      }
      // else if (checkdateOfDispatch.length > 0) {
      //   CustomToast.error(
      //     "Please select/enter Date of Dispatch in row no.  " +
      //       checkdateOfDispatch?.join(",") +
      //       " "
      //   );
      //   return false;
      // }
      else if (checkawrDate.length > 0) {
        CustomToast.error(
          "Enter the appropriate AWR Date in row no.  " +
            checkawrDate?.join(",") +
            " "
        );
        return false;
      } else if (checkarrivalDate.length > 0) {
        CustomToast.error(
          "Select the date of arrival in row no " +
            checkarrivalDate?.join(",") +
            " "
        );
        return false;
      } else if (checkgpNo.length > 0) {
        CustomToast.error(
          "Please select/enter appropriate GP No in row no. " +
            checkgpNo?.join(",") +
            " "
        );
        return false;
      } else if (rowInvalidGpNo.length > 0) {
        CustomToast.error(
          `Please enter a valid GP NO (Alphanumeric only) in row no. ${rowInvalidGpNo.join(
            ", "
          )}.`
        );
        return false;
      } else if (checkgpDate.length > 0) {
        CustomToast.error(
          "Please select / enter appropriate GP Date in row no.  " +
            checkgpDate?.join(",") +
            " "
        );
        return false;
      } else if (checkinvoiceNo.length > 0) {
        CustomToast.error(
          "Please select/enter Invoice No in row no.  " +
            checkinvoiceNo?.join(",") +
            " "
        );
        return false;
      } else if (checkTeaType.length > 0) {
        CustomToast.error(
          "Please select/enter Tea Type in row no.  " +
            checkTeaType?.join(",") +
            " "
        );
        return false;
      } else if (checkSubTeaType.length > 0) {
        CustomToast.error(
          "Please select/enter Sub Tea Type in row no.  " +
            checkSubTeaType?.join(",") +
            " "
        );
        return false;
      } else if (checkCategory.length > 0) {
        CustomToast.error(
          "Please select/enter Category in row no.  " +
            checkCategory?.join(",") +
            " "
        );
        return false;
      } else if (checkGrade.length > 0) {
        CustomToast.error(
          "Please select/enter Grade in row no.  " + checkGrade?.join(",") + " "
        );
        return false;
      } else if (checkpackageType.length > 0) {
        CustomToast.error(
          "Please select/enter packageType in row no.  " +
            checkpackageType?.join(",") +
            " "
        );
        return false;
      } else if (checkpackageNo.length > 0) {
        CustomToast.error(
          "Please select/enter package No in row no.  " +
            checkpackageNo?.join(",") +
            " "
        );
        return false;
      }
      // else if (checkgrossKgs.length > 0) {
      //   CustomToast.error(
      //     "Gross KGs cannot be Blank or ZERO in row no.  " +
      //     checkgrossKgs?.join(",") +
      //     " "
      //   );
      //   return false;
      // }
      else if (chkgrosskgsnege.length > 0) {
        CustomToast.error(
          "Please enter appropriate Gross KGs in row no.  " +
            chkgrosskgsnege?.join(",") +
            " "
        );
        return false;
      } else if (checkgrossKgs1.length > 0) {
        CustomToast.error(
          "Please enter appropriate Gross KGs in row no.  " +
            checkgrossKgs1?.join(",") +
            " "
        );
        return false;
      } else if (checktareKgsnege.length > 0) {
        CustomToast.error(
          "Please enter appropriate Tare KGs in row no.  " +
            checktareKgsnege?.join(",") +
            " "
        );
        return false;
      } else if (checktareKgs.length > 0) {
        CustomToast.error(
          "Please enter appropriate Tare KGs in row no.  " +
            checktareKgs?.join(",") +
            " "
        );
        return false;
      }
      // else if (checkgrossKgs.length > 0) {
      //   CustomToast.error(
      //     "Please enter appropriate Gross KGs in row no.  " +
      //     checkgrossKgs?.join(",") +
      //     " "
      //   );
      //   return false;
      // }
      else if (checknetKgsnegetive.length > 0) {
        CustomToast.error(
          "Tare KGs cannot be greater than or equal to Gross KGs in Row No.  " +
            checknetKgsnegetive?.join(",") +
            " "
        );
        return false;
      } else if (checknetKgs.length > 0) {
        CustomToast.error(
          "Please select/enter net Kgs in row no.  " +
            checknetKgs?.join(",") +
            " "
        );
        return false;
      } else if (
        !checkdateOfDispatch.length > 0 &&
        checkgreatethanandlessthandateofdispatch.length > 0
      ) {
        // //debugger;
        CustomToast.error(
          "Date of Dispatch Should be greater than or equal to Invoice Date in Row No. " +
            // "Greater than or equal to Invoice Date."
            checkgreatethanandlessthandateofdispatch?.join(",")
        );
        return false;
      } else if (checkdateofdispatchbycatalogclosing.length > 0) {
        CustomToast.error(
          "Date of Dispatch Should be Less than or equal to Catalog Closing Date in Row No. " +
            checkdateofdispatchbycatalogclosing?.join(",")
        );
        return false;
      }

      //else {
      // console.log(
      //   toastMessages,
      //   "invoiceDatainvoiceDatainvoiceData"
      // );\
      // axiosMain
      //   .post(
      //     " /preauction/InvoiceDetails/AddInvoiceDetails",
      //     invoiceData
      //   )
      //   .then((response) => {
      //     if (response.data.statusCode === 204) {
      //       CustomToast.success("Invoice submitted successfully");
      //     }
      //     // Handle the response data or success
      //   })
      //   .catch((error) => {
      //     CustomToast.error("API call failed:", error);
      //     // Handle errors here
      //   });
      // return true;
      //}
      //End sedit
      // const allTrue = toastMessages.every((element) => element === true);

      // if (allTrue) {
      //
      const validnumgpno = fileData
        ?.map(
          (ele) =>
            (typeof (ele.gpNo === "" ? 0 : ele.gpNo) === "number") === true
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkGrossAndTeraKgs1 = fileData
        ?.map(
          (ele) =>
            ele?.grossKgs?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
            ele.grossKgs?.toString()?.trim()?.split(".")[1] === undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);
      const checkTeraKgs1 = fileData
        ?.map(
          (ele) =>
            ele?.tareKgs?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
            ele.tareKgs?.toString()?.trim()?.split(".")[1] === undefined
        )
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);
      //imple
      console.log(
        fileData?.map(
          (ele) =>
            ele?.tareKgs?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
            ele?.tareKgs?.toString()?.trim()?.split(".")[1] === undefined
        ),
        fileData
          ?.map(
            (ele) =>
              ele?.tareKgs?.toString()?.trim()?.split(".")[1]?.length <= 2
          )
          .includes(true),
        "samardas"
      );
      //
      let checkPackageNoValue = fileData?.findIndex((ele, index) => {
        let value = ele.packageNo?.toString()?.trim();

        // Validate the format: it should be digits followed by a hyphen and more digits
        if (!/^\d+-\d+$/.test(value)) {
          return true; // Invalid format
        }

        const [start, end] = value.split("-");

        // Ensure the start value is less than the end value
        if (parseInt(start) > parseInt(end)) {
          return true; // Invalid range
        }

        return false; // The package number is valid
      });

      const manadatory = [
        "season",
        "saleNo",
        "Warehouse",
        "Auctioneer",
        "invoiceDate",
        "invoiceNo",
        "arrivalDate",
        "awrDate",
        "TeaType",
        "SubTeaType",
        "Category",
        "Grade",
        "packageType",
        "packageNo",
        "grossKgs",
        "tareKgs",
        "netKgs",
        "gpNo",
        "gpDate",
        //"dateOfDispatch",
      ];
      let checkmanadatoryManadatory = manadatory
        ?.map((item) => fileData.map((ele) => (ele[item] === "" ? item : "")))
        ?.reduce((acc, cur) => cur.concat(acc), [])
        ?.filter((ele) => ele !== "");
      let errorparam = manadatory
        ?.map((item) => fileData.map((ele) => (ele[item] === "" ? item : "")))
        ?.reduce((acc, cur) => cur.concat(acc), [])
        ?.filter((ele) => ele !== "")
        .join();

      // if (
      //   fileData
      //     .map(
      //       (ele) =>
      //         // Number.isInteger(ele.gpNo === "" ? 0 : ele.gpNo) === true ||
      //         (typeof (ele.gpNo === "" ? 0 : ele.gpNo) === "number") === true
      //     )
      //     .includes(false)
      // ) {
      //   CustomToast.error(
      //     "Please enter valid GP NO. in Row NO. " +
      //       validnumgpno?.join(",") +
      //       " "
      //   );
      //   return false;
      // }
      // else if (
      //   checkmanadatoryManadatory.length > 0
      // ) {
      //   CustomToast.error(
      //     errorparam + " are Mandatory"
      //   );
      //   return false;
      // }
       if (
        fileData
          ?.map(
            (ele) =>
              ele?.grossKgs?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
              ele?.grossKgs?.toString()?.trim()?.split(".")[1] === undefined
          )
          .includes(false)
      ) {
        // console.log(checkGrossAndTeraKgs);
        CustomToast.error(
          "Gross KGs cannot be Blank or ZERO in row no. " +
            checkGrossAndTeraKgs1?.join(",") +
            " "
        );
        return false;
        // //debugger;
      } else if (
        fileData
          ?.map(
            (ele) =>
              ele?.tareKgs?.toString()?.trim()?.split(".")[1]?.length <= 2 ||
              ele?.tareKgs?.toString()?.trim()?.split(".")[1] === undefined
          )
          .includes(false)
      ) {
        CustomToast.error(
          "Please enter appropriate Tare KGs in row no. " +
            checkTeraKgs1?.join(",") +
            " "
        );
        return false;
      } else if (checkPackageNoValue !== -1) {
        // //debugger
        CustomToast.error(
          "Enter the appropriate package number.For example, 1-25, 10-50, 001-0030, etc."
          // checkPackageNoValue?.join(",")
        );
        return false;
      }

      openLoader();
      axiosMain
        .post(
          `/preauction/${baseUrlEng}/UploadAWRDetails?role=` +
            roleCode +
            `&saleNo=${fileData?.at(0)?.saleNo}&validateAction=validate`,
          fileData.map((item) => ({
            ...item,
            gpNo: item.gpNo === "" ? null : item.gpNo,
            Category: item.Category?.toString()?.trim(),
            Grade: item.Grade?.toString()?.trim(),
            Mark: item.Mark?.toString()?.trim(),
            SubTeaType: item.SubTeaType?.toString()?.trim(),
            TeaType: item.TeaType?.toString()?.trim(),
            Warehouse: item.Warehouse?.toString()?.trim(),
            shortExcessWeight: parseFloat(item.shortExcessWeight),
            invoiceQty: parseFloat(item.invoiceQty),
            totalNetKgs: parseFloat(item.totalNetKgs),
            basicAED: item.basic_AED,
          }))
        )
        .then((response) => {
          if (response.data.statusCode === 202) {
            // console.log(fileData, "fileDatafileDatafileData");
            setopenConformationModalss(true);

            CustomToast.success(response.data.message);
          } else if (response.data.statusCode === 423) {
            // CustomToast.warning(response.data.message);
            setOpenModalConformationInvalidData(true);
            setOpenModalConformationInvalidDataTitle({
              title: response.data.message,
              responseData: response.data.responseData,
            });
            console.log(response.data, "response.data.message");
          } else {
            CustomToast.error(response.data.message);
            setopenConformationModalss(false);
          }
          // Handle the response data or success
          closeLoader();
        })
        .catch((error) => {
          CustomToast.error("Something went wrong", error);
          closeLoader();
          // Handle errors here
        });
      //
      // } else {
      //   console.log("Not all elements are true.");
      // }

      // console.log(toastMessages, "toastMessages");
    } else CustomToast.error("Validation is unsuccessful");
    // CustomToast.error(`File with 0 KB size is not allowed.`);
  }

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        {/* <div className="row mt-3">
          <div className="col-md-12">
            <Card className="mt-3 FileUploadBox">
              <Card.Body>
                <Card.Title>File Upload</Card.Title>
                {/* <div className="row">
                  <div className="col-lg-auto">
                    <div className="FileUpload">
                      <FileUpload
                        id="fileInput"
                        handleData={handleData}
                        readFileAndCheckHeaders={readFileAndCheckHeaders}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="BtnGroup">
                      <button
                        className="SubmitBtn"
                        onClick={() => handleAddData()}
                      >
                        Add
                      </button>

                      <button
                        className="SubmitBtn"
                        onClick={() => validation(fileData)}
                      >
                        Validate
                      </button>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div> */}
        <p className="Red" style={{ "font-weight": "bold" }}>
          *Certified that the Teas were weighed at the time of disbatch and
          weights stated are correct. “We here by certify that foods mentioned
          in the invoice are warranted to be of the nature and quality which it
          purports to be, and conform to the P.F.A. Act, 1954 (Act No. 37 of
          1954)”
        </p>
        <br />
        <br />
        {/* <p className="Red" style={{ "font-weight": "bold" }}>
          Note: Same Awr no. cannot be used in same “Sale No.”. It should be
          unique for each combination of season, sale number, auctioneer, mark,
          and warehouse. You can reuse the same awr number only if at least one
          of these details changes.
        </p> */}
        {/* <br />
        <br /> */}
        <ul style={{ "font-weight": "bold", marginLeft: "2rem !important" }}>
          <li>
            <p className="Red">● Any number of excel file can be uploaded.</p>
          </li>
          <li>
            <p className="Red">● Maximum file size should not exceed 10 MB.</p>
          </li>
          <li>
            <p className="Red">● Acceptable file types: (*.xls and .xlsx)</p>
          </li>
        </ul>
        <div className="row">
          <div className="col-md-12">
            <div className="row mt-3">
              <div className="col-md-12">
                <div className="BtnGroup">
                  <button
                    className="SubmitBtn"
                    type="button"
                    onClick={() => {
                      setFileData([]);
                      setTableData([]);
                      document.getElementById("file-upload").value = "";
                    }}
                  >
                    Clear
                  </button>
                  {/* {modalRight?.includes("7") && (
                    <button
                      type="button"
                      className="SubmitBtn"
                      onClick={handleDownload}
                    >
                      Download Format
                    </button>
                  )} */}
                </div>
              </div>
              {isDisabled
                ? ""
                : modalRight?.includes("6") && (
                    <div className="col-md-12 mt-3">
                      <div className="browse-file FileUpload px-0">
                        {/* <FileUpload
              id="fileInput"
              handleData={handleData}
              readFileAndCheckHeaders={readFileAndCheckHeaders}
            /> */}
                        <button
                          className="SubmitBtn"
                          type="button"
                          onClick={handleButtonClick}
                        >
                          Browse
                        </button>

                        <input
                          type="file"
                          id="file-upload"
                          ref={fileInputRef}
                          onChange={handleFileUpload}
                          multiple
                          accept=".xls,.xlsx"
                        />
                        <button
                          className="SubmitBtn creat-btn"
                          onClick={() => submitAwrDetails()}
                        >
                          Validate
                        </button>
                      </div>
                    </div>
                  )}
              {/* <div className="col-md-6">
            <div className="row">
              <div className="col-md-6">
                
              </div>
              {/* <div className="col-md-6">
                <button
                  className="SubmitBtn"
                  onClick={() => validation(fileData)}
                >
                  Validate
                </button>
                <div
                  id="loader"
                  className="spinner-border text-light"
                  style={{ display: "none" }}
                ></div>
              </div> 
            </div>
          </div> */}
            </div>

            <div className="TableBox mt-3">
              <TableComponent
                columns={propertyNameList}
                rows={fileData?.length > 0 ? fileData : []}
                setRows={setFileData}
                dragdrop={true}
                module="pre-auction"
                fixedColumnsOn={false}
                resizeingCol={false}
                selectionCol={true}
                sorting={true}
              />

              <div>
                {isDisabled ? (
                  <>
                    <div className="col-md-12 mt-3">
                      <div className="BtnGroup">
                        {/* <button
                          type="button"
                          className="SubmitBtn"
                          onClick={handlePrint}
                        >
                          Print Page
                        </button> */}
                        <button
                          className="SubmitBtn"
                          onClick={handleExportToPdf}
                        >
                          Print
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        {/* MODAL PRINT */}
        <Modals
          size="l"
          title="Chose For Print"
          show={openPrintModel}
          handleClose={() => {
            setopenPrintModel(false);
          }}
        >
          <PrintInvoice
            fields={[]}
            showcheckboxlebels={AwrPrintArr}
            rows={printrow.length > 0 ? printrow : []}
            pageName={"AWR"}
          />
        </Modals>

        <Modals
          show={openModalConformationInvalidData}
          size="xl"
          // onHide={() => setShow(false)}
          handleClose={() => {
            setopenConformationModalss(false);
            setOpenModalConformationInvalidData(false);
          }}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          title={openModalConformationInvalidDataTitle?.title}
        >
          <ul>
            {openModalConformationInvalidDataTitle?.responseData?.length > 0
              ? openModalConformationInvalidDataTitle?.responseData?.map(
                  (ele, index) => <li key={index}>● {ele.InvalidRecord}</li>
                )
              : ""}
          </ul>
        </Modals>
      </form>

      <Modals
        size="l"
        title="Are you sure you want to submit the AWR ?"
        show={openConformationModals}
        handleClose={() => {
          setopenConformationModalss(false);
        }}
      >
        <div className="BtnGroup" style={{ justifyContent: "end" }}>
          <button
            // className="SubmitBtn"
            className="SubmitBtn"
            onClick={() => {
              openLoader();
              axiosMain
                .post(
                  `/preauction/${baseUrlEng}/UploadAWRDetails?role=` +
                    roleCode +
                    `&saleNo=${fileData?.at(0)?.saleNo}&validateAction=submit`,
                  fileData.map((item) => ({
                    ...item,
                    gpNo: item.gpNo === "" ? null : item.gpNo,
                    Category: item.Category?.toString()?.trim(),
                    Grade: item.Grade?.toString()?.trim(),
                    Mark: item.Mark?.toString()?.trim(),
                    SubTeaType: item.SubTeaType?.toString()?.trim(),
                    TeaType: item.TeaType?.toString()?.trim(),
                    Warehouse: item.Warehouse?.toString()?.trim(),
                    invoiceQty: parseFloat(item.invoiceQty),
                    totalNetKgs: parseFloat(item.totalNetKgs),
                    shortExcessWeight: parseFloat(item.shortExcessWeight),
                    basicAED: item.basic_AED,
                  }))
                )
                .then((response) => {
                  if (response.data.statusCode === 200) {
                    setFileData([]);
                    CustomToast.success(response.data.message);
                    setExpandedTab("panel1");
                    formik.resetForm();
                    setTableData([]);
                    getAwr();
                    setopenConformationModalss(false);
                  } else if (response.data.statusCode === 423) {
                    // CustomToast.warning(response.data.message);
                    setOpenModalConformationInvalidData(true);
                    setOpenModalConformationInvalidDataTitle({
                      title: response.data.message,
                      responseData: response.data.responseData,
                    });
                    console.log(response.data, "response.data.message");
                  } else if (response.data.statusCode === 403) {
                    CustomToast.error(response.data.message);
                    setopenConformationModalss(false);
                  } else if (response.data.statusCode === 204) {
                    CustomToast.error(response.data.message);
                    setopenConformationModalss(false);
                  } else {
                    CustomToast.error(response.data.message);
                    setopenConformationModalss(false);
                  }
                  // Handle the response data or success
                  closeLoader();
                })
                .catch((error) => {
                  CustomToast.error("Something went wrong", error);
                  closeLoader();
                  // Handle errors here
                });
            }}
          >
            Submit
          </button>

          <button
            className="SubmitBtn"
            // className="SubmitBtn"
            onClick={() => {
              document.getElementById("file-upload").value = "";
              setopenConformationModalss(false);
              setTableData([]);
              setFileData([]);
              // setTableData([]);
            }}
          >
            Cancel
          </button>
        </div>
      </Modals>

      {/* <ToastContainer autoClose={1200} /> */}
    </div>
  );
}

export default UploadForm;
